import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4a00e952 = () => interopDefault(import('../pages/black-friday.vue' /* webpackChunkName: "pages/black-friday" */))
const _e786ee66 = () => interopDefault(import('../pages/blog-led-accessoires-vehicules/index.vue' /* webpackChunkName: "pages/blog-led-accessoires-vehicules/index" */))
const _5566fc52 = () => interopDefault(import('../pages/bonnes-affaires/index.vue' /* webpackChunkName: "pages/bonnes-affaires/index" */))
const _640069a4 = () => interopDefault(import('../pages/calendrier-avent.vue' /* webpackChunkName: "pages/calendrier-avent" */))
const _06b7b198 = () => interopDefault(import('../pages/cgv.vue' /* webpackChunkName: "pages/cgv" */))
const _5e03108b = () => interopDefault(import('../pages/charte-donnees-personnelles.vue' /* webpackChunkName: "pages/charte-donnees-personnelles" */))
const _688b551b = () => interopDefault(import('../pages/chasse-aux-leds.vue' /* webpackChunkName: "pages/chasse-aux-leds" */))
const _e6d1ee48 = () => interopDefault(import('../pages/code-promo/index.vue' /* webpackChunkName: "pages/code-promo/index" */))
const _9f1b5da6 = () => interopDefault(import('../pages/compte/index.vue' /* webpackChunkName: "pages/compte/index" */))
const _444af08a = () => interopDefault(import('../pages/compte-pro.vue' /* webpackChunkName: "pages/compte-pro" */))
const _46e17912 = () => interopDefault(import('../pages/connexion/index.vue' /* webpackChunkName: "pages/connexion/index" */))
const _e64111b4 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _453c97f6 = () => interopDefault(import('../pages/felicitations.vue' /* webpackChunkName: "pages/felicitations" */))
const _25046844 = () => interopDefault(import('../pages/inscription.vue' /* webpackChunkName: "pages/inscription" */))
const _6e9d7217 = () => interopDefault(import('../pages/livraison.vue' /* webpackChunkName: "pages/livraison" */))
const _3e26f7e4 = () => interopDefault(import('../pages/magasin-excideuil/index.vue' /* webpackChunkName: "pages/magasin-excideuil/index" */))
const _5f4a96e4 = () => interopDefault(import('../pages/marques-vehicules/index.vue' /* webpackChunkName: "pages/marques-vehicules/index" */))
const _79a8b8e6 = () => interopDefault(import('../pages/mentions-legales.vue' /* webpackChunkName: "pages/mentions-legales" */))
const _c3e1f8ba = () => interopDefault(import('../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _41f085fa = () => interopDefault(import('../pages/nouveau-mot-de-passe.vue' /* webpackChunkName: "pages/nouveau-mot-de-passe" */))
const _355382f5 = () => interopDefault(import('../pages/paiement-securise.vue' /* webpackChunkName: "pages/paiement-securise" */))
const _99507574 = () => interopDefault(import('../pages/panier/index.vue' /* webpackChunkName: "pages/panier/index" */))
const _21302bc9 = () => interopDefault(import('../pages/plan-du-site.vue' /* webpackChunkName: "pages/plan-du-site" */))
const _688c9139 = () => interopDefault(import('../pages/quiz-saint-valentin.vue' /* webpackChunkName: "pages/quiz-saint-valentin" */))
const _9a99652c = () => interopDefault(import('../pages/reglement-du-jeu.vue' /* webpackChunkName: "pages/reglement-du-jeu" */))
const _215cb8c8 = () => interopDefault(import('../pages/retour-remboursement.vue' /* webpackChunkName: "pages/retour-remboursement" */))
const _994db1d0 = () => interopDefault(import('../pages/blog-led-accessoires-vehicules/comparatif-meilleures-ampoules-led-h7.vue' /* webpackChunkName: "pages/blog-led-accessoires-vehicules/comparatif-meilleures-ampoules-led-h7" */))
const _6c02e62f = () => interopDefault(import('../pages/blog-led-accessoires-vehicules/meilleures-ampoules-feux-de-croisement-peugeot-2008.vue' /* webpackChunkName: "pages/blog-led-accessoires-vehicules/meilleures-ampoules-feux-de-croisement-peugeot-2008" */))
const _fc512550 = () => interopDefault(import('../pages/blog-led-accessoires-vehicules/verifier-eclairage-voiture.vue' /* webpackChunkName: "pages/blog-led-accessoires-vehicules/verifier-eclairage-voiture" */))
const _63ffcc5c = () => interopDefault(import('../pages/compte/adresses/index.vue' /* webpackChunkName: "pages/compte/adresses/index" */))
const _aa8cbf64 = () => interopDefault(import('../pages/compte/affiliation/index.vue' /* webpackChunkName: "pages/compte/affiliation/index" */))
const _4b6ee898 = () => interopDefault(import('../pages/compte/alertes-disponibilite/index.vue' /* webpackChunkName: "pages/compte/alertes-disponibilite/index" */))
const _cbf4dfd2 = () => interopDefault(import('../pages/compte/commandes/index.vue' /* webpackChunkName: "pages/compte/commandes/index" */))
const _ef98d674 = () => interopDefault(import('../pages/compte/favoris/index.vue' /* webpackChunkName: "pages/compte/favoris/index" */))
const _7def1a1c = () => interopDefault(import('../pages/compte/historique.vue' /* webpackChunkName: "pages/compte/historique" */))
const _01b2313f = () => interopDefault(import('../pages/compte/informations/index.vue' /* webpackChunkName: "pages/compte/informations/index" */))
const _3c7a31db = () => interopDefault(import('../pages/compte/paniers-sauvegardes/index.vue' /* webpackChunkName: "pages/compte/paniers-sauvegardes/index" */))
const _e2b0df12 = () => interopDefault(import('../pages/compte/professionnel/index.vue' /* webpackChunkName: "pages/compte/professionnel/index" */))
const _5bb4f147 = () => interopDefault(import('../pages/compte/retours-produits/index.vue' /* webpackChunkName: "pages/compte/retours-produits/index" */))
const _20ce67ca = () => interopDefault(import('../pages/compte/service-client/index.vue' /* webpackChunkName: "pages/compte/service-client/index" */))
const _4756470e = () => interopDefault(import('../pages/panier/annulation.vue' /* webpackChunkName: "pages/panier/annulation" */))
const _2717c9f1 = () => interopDefault(import('../pages/panier/confirmation.vue' /* webpackChunkName: "pages/panier/confirmation" */))
const _f1e60bf6 = () => interopDefault(import('../pages/panier/livraison.vue' /* webpackChunkName: "pages/panier/livraison" */))
const _d0bd6332 = () => interopDefault(import('../pages/panier/paiement.vue' /* webpackChunkName: "pages/panier/paiement" */))
const _4302616d = () => interopDefault(import('../pages/qui-sommes-nous/partenaires.vue' /* webpackChunkName: "pages/qui-sommes-nous/partenaires" */))
const _2e273f32 = () => interopDefault(import('../pages/qui-sommes-nous/installation-led-accessoires-vehicules/_slug.vue' /* webpackChunkName: "pages/qui-sommes-nous/installation-led-accessoires-vehicules/_slug" */))
const _1bd6b702 = () => interopDefault(import('../pages/magasin-excideuil/realisations/_slug.vue' /* webpackChunkName: "pages/magasin-excideuil/realisations/_slug" */))
const _74dac782 = () => interopDefault(import('../pages/compte/commandes/_id/index.vue' /* webpackChunkName: "pages/compte/commandes/_id/index" */))
const _1c8c996f = () => interopDefault(import('../pages/compte/retours-produits/_id.vue' /* webpackChunkName: "pages/compte/retours-produits/_id" */))
const _5f911943 = () => interopDefault(import('../pages/compte/service-client/_id.vue' /* webpackChunkName: "pages/compte/service-client/_id" */))
const _76db8878 = () => interopDefault(import('../pages/compte/commandes/_id/retours.vue' /* webpackChunkName: "pages/compte/commandes/_id/retours" */))
const _eaf430f6 = () => interopDefault(import('../pages/blog-led-accessoires-vehicules/_slug.vue' /* webpackChunkName: "pages/blog-led-accessoires-vehicules/_slug" */))
const _dbc25856 = () => interopDefault(import('../pages/photo-avis/_token.vue' /* webpackChunkName: "pages/photo-avis/_token" */))
const _35f76d5d = () => interopDefault(import('../pages/categories/_domain/index.vue' /* webpackChunkName: "pages/categories/_domain/index" */))
const _a8d682fe = () => interopDefault(import('../pages/preferences-newsletter/_token.vue' /* webpackChunkName: "pages/preferences-newsletter/_token" */))
const _2b7259e2 = () => interopDefault(import('../pages/confirmation-newsletter/_token.vue' /* webpackChunkName: "pages/confirmation-newsletter/_token" */))
const _1686c2aa = () => interopDefault(import('../pages/ajout-avis/_token/index.vue' /* webpackChunkName: "pages/ajout-avis/_token/index" */))
const _7ea75f13 = () => interopDefault(import('../pages/connexion/_provider/index.vue' /* webpackChunkName: "pages/connexion/_provider/index" */))
const _35b00bac = () => interopDefault(import('../pages/produit/_slug.vue' /* webpackChunkName: "pages/produit/_slug" */))
const _53b05b0a = () => interopDefault(import('../pages/bonnes-affaires/_slug.vue' /* webpackChunkName: "pages/bonnes-affaires/_slug" */))
const _891d5c10 = () => interopDefault(import('../pages/service-client/_id.vue' /* webpackChunkName: "pages/service-client/_id" */))
const _5d93f59c = () => interopDefault(import('../pages/marques-vehicules/_slug.vue' /* webpackChunkName: "pages/marques-vehicules/_slug" */))
const _06c0872a = () => interopDefault(import('../pages/categories/_domain/_category/index.vue' /* webpackChunkName: "pages/categories/_domain/_category/index" */))
const _e4af605a = () => interopDefault(import('../pages/ajout-avis/_token/_id.vue' /* webpackChunkName: "pages/ajout-avis/_token/_id" */))
const _32165d79 = () => interopDefault(import('../pages/categories/_domain/_category/_subcategory/index.vue' /* webpackChunkName: "pages/categories/_domain/_category/_subcategory/index" */))
const _85cc14f6 = () => interopDefault(import('../pages/recherche-led-accessoires/_brand/_type/_typeid/index.vue' /* webpackChunkName: "pages/recherche-led-accessoires/_brand/_type/_typeid/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/black-friday",
    component: _4a00e952,
    name: "black-friday___fr"
  }, {
    path: "/blog-led-accessoires-vehicules",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___fr"
  }, {
    path: "/bonnes-affaires",
    component: _5566fc52,
    name: "bonnes-affaires___fr"
  }, {
    path: "/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___fr"
  }, {
    path: "/cgv",
    component: _06b7b198,
    name: "cgv___fr"
  }, {
    path: "/charte-donnees-personnelles",
    component: _5e03108b,
    name: "charte-donnees-personnelles___fr"
  }, {
    path: "/chasse-aux-leds",
    component: _688b551b,
    name: "chasse-aux-leds___fr"
  }, {
    path: "/code-promo",
    component: _e6d1ee48,
    name: "code-promo___fr"
  }, {
    path: "/compte",
    component: _9f1b5da6,
    name: "compte___fr"
  }, {
    path: "/compte-pro",
    component: _444af08a,
    name: "compte-pro___fr"
  }, {
    path: "/connexion",
    component: _46e17912,
    name: "connexion___fr"
  }, {
    path: "/contact",
    component: _e64111b4,
    name: "contact___fr"
  }, {
    path: "/cs",
    component: _2dfb1658,
    name: "index___cs"
  }, {
    path: "/da",
    component: _2dfb1658,
    name: "index___da"
  }, {
    path: "/de",
    component: _2dfb1658,
    name: "index___de"
  }, {
    path: "/el",
    component: _2dfb1658,
    name: "index___el"
  }, {
    path: "/en",
    component: _2dfb1658,
    name: "index___en"
  }, {
    path: "/es",
    component: _2dfb1658,
    name: "index___es"
  }, {
    path: "/felicitations",
    component: _453c97f6,
    name: "felicitations___fr"
  }, {
    path: "/fi",
    component: _2dfb1658,
    name: "index___fi"
  }, {
    path: "/inscription",
    component: _25046844,
    name: "inscription___fr"
  }, {
    path: "/it",
    component: _2dfb1658,
    name: "index___it"
  }, {
    path: "/ja",
    component: _2dfb1658,
    name: "index___ja"
  }, {
    path: "/livraison",
    component: _6e9d7217,
    name: "livraison___fr"
  }, {
    path: "/magasin-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___fr"
  }, {
    path: "/marques-vehicules",
    component: _5f4a96e4,
    name: "marques-vehicules___fr"
  }, {
    path: "/mentions-legales",
    component: _79a8b8e6,
    name: "mentions-legales___fr"
  }, {
    path: "/newsletter",
    component: _c3e1f8ba,
    name: "newsletter___fr"
  }, {
    path: "/nl",
    component: _2dfb1658,
    name: "index___nl"
  }, {
    path: "/no",
    component: _2dfb1658,
    name: "index___no"
  }, {
    path: "/nouveau-mot-de-passe",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___fr"
  }, {
    path: "/paiement-securise",
    component: _355382f5,
    name: "paiement-securise___fr"
  }, {
    path: "/panier",
    component: _99507574,
    name: "panier___fr"
  }, {
    path: "/pl",
    component: _2dfb1658,
    name: "index___pl"
  }, {
    path: "/plan-du-site",
    component: _21302bc9,
    name: "plan-du-site___fr"
  }, {
    path: "/pt",
    component: _2dfb1658,
    name: "index___pt"
  }, {
    path: "/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___fr"
  }, {
    path: "/reglement-du-jeu",
    component: _9a99652c,
    name: "reglement-du-jeu___fr"
  }, {
    path: "/retour-remboursement",
    component: _215cb8c8,
    name: "retour-remboursement___fr"
  }, {
    path: "/ro",
    component: _2dfb1658,
    name: "index___ro"
  }, {
    path: "/sv",
    component: _2dfb1658,
    name: "index___sv"
  }, {
    path: "/blog-led-accessoires-vehicules/comparatif-meilleures-ampoules-led-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___fr"
  }, {
    path: "/blog-led-accessoires-vehicules/meilleures-ampoules-feux-de-croisement-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___fr"
  }, {
    path: "/blog-led-accessoires-vehicules/verifier-eclairage-voiture",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___fr"
  }, {
    path: "/compte/adresses",
    component: _63ffcc5c,
    name: "compte-adresses___fr"
  }, {
    path: "/compte/affiliation",
    component: _aa8cbf64,
    name: "compte-affiliation___fr"
  }, {
    path: "/compte/alertes-disponibilite",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___fr"
  }, {
    path: "/compte/commandes",
    component: _cbf4dfd2,
    name: "compte-commandes___fr"
  }, {
    path: "/compte/favoris",
    component: _ef98d674,
    name: "compte-favoris___fr"
  }, {
    path: "/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___fr"
  }, {
    path: "/compte/informations",
    component: _01b2313f,
    name: "compte-informations___fr"
  }, {
    path: "/compte/paniers-sauvegardes",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___fr"
  }, {
    path: "/compte/professionnel",
    component: _e2b0df12,
    name: "compte-professionnel___fr"
  }, {
    path: "/compte/retours-produits",
    component: _5bb4f147,
    name: "compte-retours-produits___fr"
  }, {
    path: "/compte/service-client",
    component: _20ce67ca,
    name: "compte-service-client___fr"
  }, {
    path: "/cs/bezpecna-platba",
    component: _355382f5,
    name: "paiement-securise___cs"
  }, {
    path: "/cs/black-friday",
    component: _4a00e952,
    name: "black-friday___cs"
  }, {
    path: "/cs/blog-led-prislusenstvi-vozidel",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___cs"
  }, {
    path: "/cs/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___cs"
  }, {
    path: "/cs/doruceni",
    component: _6e9d7217,
    name: "livraison___cs"
  }, {
    path: "/cs/gratuluji",
    component: _453c97f6,
    name: "felicitations___cs"
  }, {
    path: "/cs/hon-za-led",
    component: _688b551b,
    name: "chasse-aux-leds___cs"
  }, {
    path: "/cs/kontakt",
    component: _e64111b4,
    name: "contact___cs"
  }, {
    path: "/cs/kosik",
    component: _99507574,
    name: "panier___cs"
  }, {
    path: "/cs/mapa-stranek",
    component: _21302bc9,
    name: "plan-du-site___cs"
  }, {
    path: "/cs/newsletter",
    component: _c3e1f8ba,
    name: "newsletter___cs"
  }, {
    path: "/cs/nove-heslo",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___cs"
  }, {
    path: "/cs/obchodni-podminky",
    component: _06b7b198,
    name: "cgv___cs"
  }, {
    path: "/cs/pravidla-souteze",
    component: _9a99652c,
    name: "reglement-du-jeu___cs"
  }, {
    path: "/cs/pravni-informace",
    component: _79a8b8e6,
    name: "mentions-legales___cs"
  }, {
    path: "/cs/prihlaseni",
    component: _46e17912,
    name: "connexion___cs"
  }, {
    path: "/cs/prodejna-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___cs"
  }, {
    path: "/cs/profesionalni-ucet",
    component: _444af08a,
    name: "compte-pro___cs"
  }, {
    path: "/cs/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___cs"
  }, {
    path: "/cs/registrace",
    component: _25046844,
    name: "inscription___cs"
  }, {
    path: "/cs/slevovy-kod",
    component: _e6d1ee48,
    name: "code-promo___cs"
  }, {
    path: "/cs/ucet",
    component: _9f1b5da6,
    name: "compte___cs"
  }, {
    path: "/cs/vraceni-a-vraceni-penez",
    component: _215cb8c8,
    name: "retour-remboursement___cs"
  }, {
    path: "/cs/vyhodne-nakupy",
    component: _5566fc52,
    name: "bonnes-affaires___cs"
  }, {
    path: "/cs/zasady-ochrany-osobnich-udaju",
    component: _5e03108b,
    name: "charte-donnees-personnelles___cs"
  }, {
    path: "/cs/znacky-vozidel",
    component: _5f4a96e4,
    name: "marques-vehicules___cs"
  }, {
    path: "/da/black-friday",
    component: _4a00e952,
    name: "black-friday___da"
  }, {
    path: "/da/blog-led-tilbehoer-koeretoejer",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___da"
  }, {
    path: "/da/butik-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___da"
  }, {
    path: "/da/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___da"
  }, {
    path: "/da/gode-tilbud",
    component: _5566fc52,
    name: "bonnes-affaires___da"
  }, {
    path: "/da/juridiske-oplysninger",
    component: _79a8b8e6,
    name: "mentions-legales___da"
  }, {
    path: "/da/koeretoejsmaerker",
    component: _5f4a96e4,
    name: "marques-vehicules___da"
  }, {
    path: "/da/konkurrencebetingelser",
    component: _9a99652c,
    name: "reglement-du-jeu___da"
  }, {
    path: "/da/kontakt",
    component: _e64111b4,
    name: "contact___da"
  }, {
    path: "/da/konto",
    component: _9f1b5da6,
    name: "compte___da"
  }, {
    path: "/da/kurv",
    component: _99507574,
    name: "panier___da"
  }, {
    path: "/da/led-jagt",
    component: _688b551b,
    name: "chasse-aux-leds___da"
  }, {
    path: "/da/levering",
    component: _6e9d7217,
    name: "livraison___da"
  }, {
    path: "/da/log-ind",
    component: _46e17912,
    name: "connexion___da"
  }, {
    path: "/da/nyhedsbrev",
    component: _c3e1f8ba,
    name: "newsletter___da"
  }, {
    path: "/da/nyt-adgangskodeord",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___da"
  }, {
    path: "/da/opret-konto",
    component: _25046844,
    name: "inscription___da"
  }, {
    path: "/da/persondatapolitik",
    component: _5e03108b,
    name: "charte-donnees-personnelles___da"
  }, {
    path: "/da/pro-konto",
    component: _444af08a,
    name: "compte-pro___da"
  }, {
    path: "/da/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___da"
  }, {
    path: "/da/rabatkode",
    component: _e6d1ee48,
    name: "code-promo___da"
  }, {
    path: "/da/retur-refusion",
    component: _215cb8c8,
    name: "retour-remboursement___da"
  }, {
    path: "/da/salgsbetingelser",
    component: _06b7b198,
    name: "cgv___da"
  }, {
    path: "/da/sikker-betaling",
    component: _355382f5,
    name: "paiement-securise___da"
  }, {
    path: "/da/sitemap",
    component: _21302bc9,
    name: "plan-du-site___da"
  }, {
    path: "/da/tillykke",
    component: _453c97f6,
    name: "felicitations___da"
  }, {
    path: "/de/agb",
    component: _06b7b198,
    name: "cgv___de"
  }, {
    path: "/de/anmeldung",
    component: _46e17912,
    name: "connexion___de"
  }, {
    path: "/de/black-friday",
    component: _4a00e952,
    name: "black-friday___de"
  }, {
    path: "/de/blog-led-zubehoer-fahrzeuge",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___de"
  }, {
    path: "/de/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___de"
  }, {
    path: "/de/charta-personenbezogene-daten",
    component: _5e03108b,
    name: "charte-donnees-personnelles___de"
  }, {
    path: "/de/fahrzeugmarken",
    component: _5f4a96e4,
    name: "marques-vehicules___de"
  }, {
    path: "/de/geschaft-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___de"
  }, {
    path: "/de/glueckwuensche",
    component: _453c97f6,
    name: "felicitations___de"
  }, {
    path: "/de/gute-angebote",
    component: _5566fc52,
    name: "bonnes-affaires___de"
  }, {
    path: "/de/gutschein-code",
    component: _e6d1ee48,
    name: "code-promo___de"
  }, {
    path: "/de/kontakt",
    component: _e64111b4,
    name: "contact___de"
  }, {
    path: "/de/konto",
    component: _9f1b5da6,
    name: "compte___de"
  }, {
    path: "/de/led-jagd",
    component: _688b551b,
    name: "chasse-aux-leds___de"
  }, {
    path: "/de/lieferung",
    component: _6e9d7217,
    name: "livraison___de"
  }, {
    path: "/de/neues-passwort",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___de"
  }, {
    path: "/de/newsletter",
    component: _c3e1f8ba,
    name: "newsletter___de"
  }, {
    path: "/de/pro-konto",
    component: _444af08a,
    name: "compte-pro___de"
  }, {
    path: "/de/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___de"
  }, {
    path: "/de/rechtliche-hinweise",
    component: _79a8b8e6,
    name: "mentions-legales___de"
  }, {
    path: "/de/registrierung",
    component: _25046844,
    name: "inscription___de"
  }, {
    path: "/de/ruckgabe-erstattung",
    component: _215cb8c8,
    name: "retour-remboursement___de"
  }, {
    path: "/de/sichere-zahlung",
    component: _355382f5,
    name: "paiement-securise___de"
  }, {
    path: "/de/sitemap",
    component: _21302bc9,
    name: "plan-du-site___de"
  }, {
    path: "/de/spielregeln",
    component: _9a99652c,
    name: "reglement-du-jeu___de"
  }, {
    path: "/de/warenkorb",
    component: _99507574,
    name: "panier___de"
  }, {
    path: "/el/asfalis-pliromi",
    component: _355382f5,
    name: "paiement-securise___el"
  }, {
    path: "/el/black-friday",
    component: _4a00e952,
    name: "black-friday___el"
  }, {
    path: "/el/blog-led-aksesouar-ochimaton",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___el"
  }, {
    path: "/el/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___el"
  }, {
    path: "/el/chartis-istotopou",
    component: _21302bc9,
    name: "plan-du-site___el"
  }, {
    path: "/el/eggrafi",
    component: _25046844,
    name: "inscription___el"
  }, {
    path: "/el/enimerotiko-deltio",
    component: _c3e1f8ba,
    name: "newsletter___el"
  }, {
    path: "/el/epaggelmatikos-logariasmos",
    component: _444af08a,
    name: "compte-pro___el"
  }, {
    path: "/el/epikoinonia",
    component: _e64111b4,
    name: "contact___el"
  }, {
    path: "/el/epistrofi-epistrofi-chrimaton",
    component: _215cb8c8,
    name: "retour-remboursement___el"
  }, {
    path: "/el/kalathi",
    component: _99507574,
    name: "panier___el"
  }, {
    path: "/el/kanonismoi-diagonismou",
    component: _9a99652c,
    name: "reglement-du-jeu___el"
  }, {
    path: "/el/katastima-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___el"
  }, {
    path: "/el/kodikos-prosforas",
    component: _e6d1ee48,
    name: "code-promo___el"
  }, {
    path: "/el/kynigi-led",
    component: _688b551b,
    name: "chasse-aux-leds___el"
  }, {
    path: "/el/logariasmos",
    component: _9f1b5da6,
    name: "compte___el"
  }, {
    path: "/el/markes-ochimaton",
    component: _5f4a96e4,
    name: "marques-vehicules___el"
  }, {
    path: "/el/neos-kodikos-prosvasis",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___el"
  }, {
    path: "/el/nomikes-plirofories",
    component: _79a8b8e6,
    name: "mentions-legales___el"
  }, {
    path: "/el/oroi-poliseon",
    component: _06b7b198,
    name: "cgv___el"
  }, {
    path: "/el/paradosi",
    component: _6e9d7217,
    name: "livraison___el"
  }, {
    path: "/el/politiki-prosopikon-dedomenon",
    component: _5e03108b,
    name: "charte-donnees-personnelles___el"
  }, {
    path: "/el/prosfores",
    component: _5566fc52,
    name: "bonnes-affaires___el"
  }, {
    path: "/el/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___el"
  }, {
    path: "/el/sundesi",
    component: _46e17912,
    name: "connexion___el"
  }, {
    path: "/el/sygcharitiria",
    component: _453c97f6,
    name: "felicitations___el"
  }, {
    path: "/en/account",
    component: _9f1b5da6,
    name: "compte___en"
  }, {
    path: "/en/black-friday",
    component: _4a00e952,
    name: "black-friday___en"
  }, {
    path: "/en/blog-led-accessories-vehicles",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___en"
  }, {
    path: "/en/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___en"
  }, {
    path: "/en/cart",
    component: _99507574,
    name: "panier___en"
  }, {
    path: "/en/congratulations",
    component: _453c97f6,
    name: "felicitations___en"
  }, {
    path: "/en/contact",
    component: _e64111b4,
    name: "contact___en"
  }, {
    path: "/en/delivery",
    component: _6e9d7217,
    name: "livraison___en"
  }, {
    path: "/en/game-rules",
    component: _9a99652c,
    name: "reglement-du-jeu___en"
  }, {
    path: "/en/good-deals",
    component: _5566fc52,
    name: "bonnes-affaires___en"
  }, {
    path: "/en/led-hunt",
    component: _688b551b,
    name: "chasse-aux-leds___en"
  }, {
    path: "/en/legal-notices",
    component: _79a8b8e6,
    name: "mentions-legales___en"
  }, {
    path: "/en/login",
    component: _46e17912,
    name: "connexion___en"
  }, {
    path: "/en/new-password",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___en"
  }, {
    path: "/en/newsletter",
    component: _c3e1f8ba,
    name: "newsletter___en"
  }, {
    path: "/en/personal-data-policy",
    component: _5e03108b,
    name: "charte-donnees-personnelles___en"
  }, {
    path: "/en/pro-account",
    component: _444af08a,
    name: "compte-pro___en"
  }, {
    path: "/en/promo-code",
    component: _e6d1ee48,
    name: "code-promo___en"
  }, {
    path: "/en/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___en"
  }, {
    path: "/en/registration",
    component: _25046844,
    name: "inscription___en"
  }, {
    path: "/en/return-refund",
    component: _215cb8c8,
    name: "retour-remboursement___en"
  }, {
    path: "/en/secure-payment",
    component: _355382f5,
    name: "paiement-securise___en"
  }, {
    path: "/en/sitemap",
    component: _21302bc9,
    name: "plan-du-site___en"
  }, {
    path: "/en/store-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___en"
  }, {
    path: "/en/tos",
    component: _06b7b198,
    name: "cgv___en"
  }, {
    path: "/en/vehicle-brands",
    component: _5f4a96e4,
    name: "marques-vehicules___en"
  }, {
    path: "/es/aviso-legal",
    component: _79a8b8e6,
    name: "mentions-legales___es"
  }, {
    path: "/es/black-friday",
    component: _4a00e952,
    name: "black-friday___es"
  }, {
    path: "/es/blog-led-accesorios-vehiculos",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___es"
  }, {
    path: "/es/boletin",
    component: _c3e1f8ba,
    name: "newsletter___es"
  }, {
    path: "/es/buenas-ofertas",
    component: _5566fc52,
    name: "bonnes-affaires___es"
  }, {
    path: "/es/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___es"
  }, {
    path: "/es/carrito",
    component: _99507574,
    name: "panier___es"
  }, {
    path: "/es/carta-datos-personales",
    component: _5e03108b,
    name: "charte-donnees-personnelles___es"
  }, {
    path: "/es/caza-de-leds",
    component: _688b551b,
    name: "chasse-aux-leds___es"
  }, {
    path: "/es/cgv",
    component: _06b7b198,
    name: "cgv___es"
  }, {
    path: "/es/codigo-promocional",
    component: _e6d1ee48,
    name: "code-promo___es"
  }, {
    path: "/es/conexion",
    component: _46e17912,
    name: "connexion___es"
  }, {
    path: "/es/contacto",
    component: _e64111b4,
    name: "contact___es"
  }, {
    path: "/es/cuenta",
    component: _9f1b5da6,
    name: "compte___es"
  }, {
    path: "/es/cuenta-pro",
    component: _444af08a,
    name: "compte-pro___es"
  }, {
    path: "/es/devolucion-reembolso",
    component: _215cb8c8,
    name: "retour-remboursement___es"
  }, {
    path: "/es/entrega",
    component: _6e9d7217,
    name: "livraison___es"
  }, {
    path: "/es/felicitaciones",
    component: _453c97f6,
    name: "felicitations___es"
  }, {
    path: "/es/inscripcion",
    component: _25046844,
    name: "inscription___es"
  }, {
    path: "/es/mapa-del-sitio",
    component: _21302bc9,
    name: "plan-du-site___es"
  }, {
    path: "/es/marcas-vehiculos",
    component: _5f4a96e4,
    name: "marques-vehicules___es"
  }, {
    path: "/es/nueva-contrasena",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___es"
  }, {
    path: "/es/pago-seguro",
    component: _355382f5,
    name: "paiement-securise___es"
  }, {
    path: "/es/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___es"
  }, {
    path: "/es/reglamento-del-juego",
    component: _9a99652c,
    name: "reglement-du-jeu___es"
  }, {
    path: "/es/tienda-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___es"
  }, {
    path: "/fi/ajoneuvomerkit",
    component: _5f4a96e4,
    name: "marques-vehicules___fi"
  }, {
    path: "/fi/alennuskoodi",
    component: _e6d1ee48,
    name: "code-promo___fi"
  }, {
    path: "/fi/black-friday",
    component: _4a00e952,
    name: "black-friday___fi"
  }, {
    path: "/fi/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___fi"
  }, {
    path: "/fi/kilpailun-saannot",
    component: _9a99652c,
    name: "reglement-du-jeu___fi"
  }, {
    path: "/fi/kirjaudu",
    component: _46e17912,
    name: "connexion___fi"
  }, {
    path: "/fi/led-ajoneuvotarvikkeet-blogi",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___fi"
  }, {
    path: "/fi/led-jahti",
    component: _688b551b,
    name: "chasse-aux-leds___fi"
  }, {
    path: "/fi/myymala-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___fi"
  }, {
    path: "/fi/myyntiehdot",
    component: _06b7b198,
    name: "cgv___fi"
  }, {
    path: "/fi/oikeudelliset-tiedot",
    component: _79a8b8e6,
    name: "mentions-legales___fi"
  }, {
    path: "/fi/onnittelut",
    component: _453c97f6,
    name: "felicitations___fi"
  }, {
    path: "/fi/ostoskori",
    component: _99507574,
    name: "panier___fi"
  }, {
    path: "/fi/palautus-hyvitys",
    component: _215cb8c8,
    name: "retour-remboursement___fi"
  }, {
    path: "/fi/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___fi"
  }, {
    path: "/fi/rekisteroidy",
    component: _25046844,
    name: "inscription___fi"
  }, {
    path: "/fi/sivustokartta",
    component: _21302bc9,
    name: "plan-du-site___fi"
  }, {
    path: "/fi/tarjoukset",
    component: _5566fc52,
    name: "bonnes-affaires___fi"
  }, {
    path: "/fi/tietosuojaseloste",
    component: _5e03108b,
    name: "charte-donnees-personnelles___fi"
  }, {
    path: "/fi/tili",
    component: _9f1b5da6,
    name: "compte___fi"
  }, {
    path: "/fi/toimitus",
    component: _6e9d7217,
    name: "livraison___fi"
  }, {
    path: "/fi/turvallinen-maksu",
    component: _355382f5,
    name: "paiement-securise___fi"
  }, {
    path: "/fi/uusi-salasana",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___fi"
  }, {
    path: "/fi/uutiskirje",
    component: _c3e1f8ba,
    name: "newsletter___fi"
  }, {
    path: "/fi/yhteystiedot",
    component: _e64111b4,
    name: "contact___fi"
  }, {
    path: "/fi/yritystili",
    component: _444af08a,
    name: "compte-pro___fi"
  }, {
    path: "/it/account",
    component: _9f1b5da6,
    name: "compte___it"
  }, {
    path: "/it/account-pro",
    component: _444af08a,
    name: "compte-pro___it"
  }, {
    path: "/it/black-friday",
    component: _4a00e952,
    name: "black-friday___it"
  }, {
    path: "/it/blog-led-accessori-veicoli",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___it"
  }, {
    path: "/it/buoni-affari",
    component: _5566fc52,
    name: "bonnes-affaires___it"
  }, {
    path: "/it/caccia-ai-led",
    component: _688b551b,
    name: "chasse-aux-leds___it"
  }, {
    path: "/it/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___it"
  }, {
    path: "/it/carrello",
    component: _99507574,
    name: "panier___it"
  }, {
    path: "/it/carta-dati-personali",
    component: _5e03108b,
    name: "charte-donnees-personnelles___it"
  }, {
    path: "/it/cgv",
    component: _06b7b198,
    name: "cgv___it"
  }, {
    path: "/it/codice-promozionale",
    component: _e6d1ee48,
    name: "code-promo___it"
  }, {
    path: "/it/congratulazioni",
    component: _453c97f6,
    name: "felicitations___it"
  }, {
    path: "/it/connessione",
    component: _46e17912,
    name: "connexion___it"
  }, {
    path: "/it/consegna",
    component: _6e9d7217,
    name: "livraison___it"
  }, {
    path: "/it/contatto",
    component: _e64111b4,
    name: "contact___it"
  }, {
    path: "/it/informazioni-legali",
    component: _79a8b8e6,
    name: "mentions-legales___it"
  }, {
    path: "/it/iscrizione",
    component: _25046844,
    name: "inscription___it"
  }, {
    path: "/it/mappa-del-sito",
    component: _21302bc9,
    name: "plan-du-site___it"
  }, {
    path: "/it/marche-veicoli",
    component: _5f4a96e4,
    name: "marques-vehicules___it"
  }, {
    path: "/it/negozio-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___it"
  }, {
    path: "/it/newsletter",
    component: _c3e1f8ba,
    name: "newsletter___it"
  }, {
    path: "/it/nuova-password",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___it"
  }, {
    path: "/it/pagamento-sicuro",
    component: _355382f5,
    name: "paiement-securise___it"
  }, {
    path: "/it/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___it"
  }, {
    path: "/it/regolamento-del-gioco",
    component: _9a99652c,
    name: "reglement-du-jeu___it"
  }, {
    path: "/it/reso-rimborso",
    component: _215cb8c8,
    name: "retour-remboursement___it"
  }, {
    path: "/ja/akaundo",
    component: _9f1b5da6,
    name: "compte___ja"
  }, {
    path: "/ja/anzen-na-shiharai",
    component: _355382f5,
    name: "paiement-securise___ja"
  }, {
    path: "/ja/black-friday",
    component: _4a00e952,
    name: "black-friday___ja"
  }, {
    path: "/ja/blog-led-akusesari-sharyo",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___ja"
  }, {
    path: "/ja/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___ja"
  }, {
    path: "/ja/gemu-kisoku",
    component: _9a99652c,
    name: "reglement-du-jeu___ja"
  }, {
    path: "/ja/haisou",
    component: _6e9d7217,
    name: "livraison___ja"
  }, {
    path: "/ja/henpin-shiharai",
    component: _215cb8c8,
    name: "retour-remboursement___ja"
  }, {
    path: "/ja/houjin-hyoji",
    component: _79a8b8e6,
    name: "mentions-legales___ja"
  }, {
    path: "/ja/kato",
    component: _99507574,
    name: "panier___ja"
  }, {
    path: "/ja/kojin-joho-hoshou-kijun",
    component: _5e03108b,
    name: "charte-donnees-personnelles___ja"
  }, {
    path: "/ja/led-hanto",
    component: _688b551b,
    name: "chasse-aux-leds___ja"
  }, {
    path: "/ja/nyu-su-reta-",
    component: _c3e1f8ba,
    name: "newsletter___ja"
  }, {
    path: "/ja/okaidoku",
    component: _5566fc52,
    name: "bonnes-affaires___ja"
  }, {
    path: "/ja/omedetou",
    component: _453c97f6,
    name: "felicitations___ja"
  }, {
    path: "/ja/otoiawase",
    component: _e64111b4,
    name: "contact___ja"
  }, {
    path: "/ja/puro-akaundo",
    component: _444af08a,
    name: "compte-pro___ja"
  }, {
    path: "/ja/puromo-kodo",
    component: _e6d1ee48,
    name: "code-promo___ja"
  }, {
    path: "/ja/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___ja"
  }, {
    path: "/ja/riyou-kiyaku",
    component: _06b7b198,
    name: "cgv___ja"
  }, {
    path: "/ja/roguin",
    component: _46e17912,
    name: "connexion___ja"
  }, {
    path: "/ja/saito-mappu",
    component: _21302bc9,
    name: "plan-du-site___ja"
  }, {
    path: "/ja/sharyou-burando",
    component: _5f4a96e4,
    name: "marques-vehicules___ja"
  }, {
    path: "/ja/shin-password",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___ja"
  }, {
    path: "/ja/tenpo-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___ja"
  }, {
    path: "/ja/touroku",
    component: _25046844,
    name: "inscription___ja"
  }, {
    path: "/nl/account",
    component: _9f1b5da6,
    name: "compte___nl"
  }, {
    path: "/nl/avw",
    component: _06b7b198,
    name: "cgv___nl"
  }, {
    path: "/nl/beveiligde-betaling",
    component: _355382f5,
    name: "paiement-securise___nl"
  }, {
    path: "/nl/black-friday",
    component: _4a00e952,
    name: "black-friday___nl"
  }, {
    path: "/nl/blog-led-accessoires-voertuigen",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___nl"
  }, {
    path: "/nl/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___nl"
  }, {
    path: "/nl/charter-persoonsgegevens",
    component: _5e03108b,
    name: "charte-donnees-personnelles___nl"
  }, {
    path: "/nl/contact",
    component: _e64111b4,
    name: "contact___nl"
  }, {
    path: "/nl/gefeliciteerd",
    component: _453c97f6,
    name: "felicitations___nl"
  }, {
    path: "/nl/goede-deals",
    component: _5566fc52,
    name: "bonnes-affaires___nl"
  }, {
    path: "/nl/inschrijving",
    component: _25046844,
    name: "inscription___nl"
  }, {
    path: "/nl/led-jacht",
    component: _688b551b,
    name: "chasse-aux-leds___nl"
  }, {
    path: "/nl/levering",
    component: _6e9d7217,
    name: "livraison___nl"
  }, {
    path: "/nl/merken-voertuigen",
    component: _5f4a96e4,
    name: "marques-vehicules___nl"
  }, {
    path: "/nl/nieuw-wachtwoord",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___nl"
  }, {
    path: "/nl/nieuwsbrief",
    component: _c3e1f8ba,
    name: "newsletter___nl"
  }, {
    path: "/nl/professioneel-account",
    component: _444af08a,
    name: "compte-pro___nl"
  }, {
    path: "/nl/promo-code",
    component: _e6d1ee48,
    name: "code-promo___nl"
  }, {
    path: "/nl/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___nl"
  }, {
    path: "/nl/retour-terugbetaling",
    component: _215cb8c8,
    name: "retour-remboursement___nl"
  }, {
    path: "/nl/sitemap",
    component: _21302bc9,
    name: "plan-du-site___nl"
  }, {
    path: "/nl/spelregels",
    component: _9a99652c,
    name: "reglement-du-jeu___nl"
  }, {
    path: "/nl/verbinding",
    component: _46e17912,
    name: "connexion___nl"
  }, {
    path: "/nl/wettelijke-vermeldingen",
    component: _79a8b8e6,
    name: "mentions-legales___nl"
  }, {
    path: "/nl/winkel-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___nl"
  }, {
    path: "/nl/winkelwagen",
    component: _99507574,
    name: "panier___nl"
  }, {
    path: "/no/bilmerker",
    component: _5f4a96e4,
    name: "marques-vehicules___no"
  }, {
    path: "/no/black-friday",
    component: _4a00e952,
    name: "black-friday___no"
  }, {
    path: "/no/blogg-led-tilbehor-kjoretoy",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___no"
  }, {
    path: "/no/butikk-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___no"
  }, {
    path: "/no/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___no"
  }, {
    path: "/no/gode-tilbud",
    component: _5566fc52,
    name: "bonnes-affaires___no"
  }, {
    path: "/no/gratulerer",
    component: _453c97f6,
    name: "felicitations___no"
  }, {
    path: "/no/handlekurv",
    component: _99507574,
    name: "panier___no"
  }, {
    path: "/no/juridisk-informasjon",
    component: _79a8b8e6,
    name: "mentions-legales___no"
  }, {
    path: "/no/konkurranseregler",
    component: _9a99652c,
    name: "reglement-du-jeu___no"
  }, {
    path: "/no/kontakt",
    component: _e64111b4,
    name: "contact___no"
  }, {
    path: "/no/konto",
    component: _9f1b5da6,
    name: "compte___no"
  }, {
    path: "/no/led-jakt",
    component: _688b551b,
    name: "chasse-aux-leds___no"
  }, {
    path: "/no/levering",
    component: _6e9d7217,
    name: "livraison___no"
  }, {
    path: "/no/logg-inn",
    component: _46e17912,
    name: "connexion___no"
  }, {
    path: "/no/nettstedskart",
    component: _21302bc9,
    name: "plan-du-site___no"
  }, {
    path: "/no/nyhetsbrev",
    component: _c3e1f8ba,
    name: "newsletter___no"
  }, {
    path: "/no/nytt-passord",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___no"
  }, {
    path: "/no/personvernerklaering",
    component: _5e03108b,
    name: "charte-donnees-personnelles___no"
  }, {
    path: "/no/proffkonto",
    component: _444af08a,
    name: "compte-pro___no"
  }, {
    path: "/no/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___no"
  }, {
    path: "/no/rabattkode",
    component: _e6d1ee48,
    name: "code-promo___no"
  }, {
    path: "/no/registrer",
    component: _25046844,
    name: "inscription___no"
  }, {
    path: "/no/retur-refusjon",
    component: _215cb8c8,
    name: "retour-remboursement___no"
  }, {
    path: "/no/salgsbetingelser",
    component: _06b7b198,
    name: "cgv___no"
  }, {
    path: "/no/sikker-betaling",
    component: _355382f5,
    name: "paiement-securise___no"
  }, {
    path: "/panier/annulation",
    component: _4756470e,
    name: "panier-annulation___fr"
  }, {
    path: "/panier/confirmation",
    component: _2717c9f1,
    name: "panier-confirmation___fr"
  }, {
    path: "/panier/livraison",
    component: _f1e60bf6,
    name: "panier-livraison___fr"
  }, {
    path: "/panier/paiement",
    component: _d0bd6332,
    name: "panier-paiement___fr"
  }, {
    path: "/pl/bezpieczna-platnosc",
    component: _355382f5,
    name: "paiement-securise___pl"
  }, {
    path: "/pl/black-friday",
    component: _4a00e952,
    name: "black-friday___pl"
  }, {
    path: "/pl/blog-led-akcesoria-pojazdow",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___pl"
  }, {
    path: "/pl/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___pl"
  }, {
    path: "/pl/dostawa",
    component: _6e9d7217,
    name: "livraison___pl"
  }, {
    path: "/pl/gratulacje",
    component: _453c97f6,
    name: "felicitations___pl"
  }, {
    path: "/pl/informacje-prawne",
    component: _79a8b8e6,
    name: "mentions-legales___pl"
  }, {
    path: "/pl/kod-promocyjny",
    component: _e6d1ee48,
    name: "code-promo___pl"
  }, {
    path: "/pl/kontakt",
    component: _e64111b4,
    name: "contact___pl"
  }, {
    path: "/pl/konto",
    component: _9f1b5da6,
    name: "compte___pl"
  }, {
    path: "/pl/konto-pro",
    component: _444af08a,
    name: "compte-pro___pl"
  }, {
    path: "/pl/koszyk",
    component: _99507574,
    name: "panier___pl"
  }, {
    path: "/pl/logowanie",
    component: _46e17912,
    name: "connexion___pl"
  }, {
    path: "/pl/mapa-strony",
    component: _21302bc9,
    name: "plan-du-site___pl"
  }, {
    path: "/pl/marki-pojazdow",
    component: _5f4a96e4,
    name: "marques-vehicules___pl"
  }, {
    path: "/pl/newsletter",
    component: _c3e1f8ba,
    name: "newsletter___pl"
  }, {
    path: "/pl/nowe-haslo",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___pl"
  }, {
    path: "/pl/okazje",
    component: _5566fc52,
    name: "bonnes-affaires___pl"
  }, {
    path: "/pl/polityka-danych-osobowych",
    component: _5e03108b,
    name: "charte-donnees-personnelles___pl"
  }, {
    path: "/pl/polowanie-na-ledy",
    component: _688b551b,
    name: "chasse-aux-leds___pl"
  }, {
    path: "/pl/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___pl"
  }, {
    path: "/pl/regulamin-gry",
    component: _9a99652c,
    name: "reglement-du-jeu___pl"
  }, {
    path: "/pl/rejestracja",
    component: _25046844,
    name: "inscription___pl"
  }, {
    path: "/pl/sklep-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___pl"
  }, {
    path: "/pl/warunki-sprzedazy",
    component: _06b7b198,
    name: "cgv___pl"
  }, {
    path: "/pl/zwrot-zwrot-srodkow",
    component: _215cb8c8,
    name: "retour-remboursement___pl"
  }, {
    path: "/pt/black-friday",
    component: _4a00e952,
    name: "black-friday___pt"
  }, {
    path: "/pt/blog-led-acessorios-veiculos",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___pt"
  }, {
    path: "/pt/boas-ofertas",
    component: _5566fc52,
    name: "bonnes-affaires___pt"
  }, {
    path: "/pt/boletim-informativo",
    component: _c3e1f8ba,
    name: "newsletter___pt"
  }, {
    path: "/pt/caca-aos-leds",
    component: _688b551b,
    name: "chasse-aux-leds___pt"
  }, {
    path: "/pt/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___pt"
  }, {
    path: "/pt/carrinho",
    component: _99507574,
    name: "panier___pt"
  }, {
    path: "/pt/carta-de-dados-pessoais",
    component: _5e03108b,
    name: "charte-donnees-personnelles___pt"
  }, {
    path: "/pt/cgv",
    component: _06b7b198,
    name: "cgv___pt"
  }, {
    path: "/pt/codigo-promocional",
    component: _e6d1ee48,
    name: "code-promo___pt"
  }, {
    path: "/pt/conexao",
    component: _46e17912,
    name: "connexion___pt"
  }, {
    path: "/pt/conta",
    component: _9f1b5da6,
    name: "compte___pt"
  }, {
    path: "/pt/conta-pro",
    component: _444af08a,
    name: "compte-pro___pt"
  }, {
    path: "/pt/contato",
    component: _e64111b4,
    name: "contact___pt"
  }, {
    path: "/pt/devolucao-reembolso",
    component: _215cb8c8,
    name: "retour-remboursement___pt"
  }, {
    path: "/pt/entrega",
    component: _6e9d7217,
    name: "livraison___pt"
  }, {
    path: "/pt/inscricao",
    component: _25046844,
    name: "inscription___pt"
  }, {
    path: "/pt/loja-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___pt"
  }, {
    path: "/pt/mapa-do-site",
    component: _21302bc9,
    name: "plan-du-site___pt"
  }, {
    path: "/pt/marcas-veiculos",
    component: _5f4a96e4,
    name: "marques-vehicules___pt"
  }, {
    path: "/pt/mencoes-legais",
    component: _79a8b8e6,
    name: "mentions-legales___pt"
  }, {
    path: "/pt/nova-senha",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___pt"
  }, {
    path: "/pt/pagamento-seguro",
    component: _355382f5,
    name: "paiement-securise___pt"
  }, {
    path: "/pt/parabens",
    component: _453c97f6,
    name: "felicitations___pt"
  }, {
    path: "/pt/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___pt"
  }, {
    path: "/pt/regulamento-do-jogo",
    component: _9a99652c,
    name: "reglement-du-jeu___pt"
  }, {
    path: "/qui-sommes-nous/partenaires",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___fr"
  }, {
    path: "/ro/autentificare",
    component: _46e17912,
    name: "connexion___ro"
  }, {
    path: "/ro/black-friday",
    component: _4a00e952,
    name: "black-friday___ro"
  }, {
    path: "/ro/blog-led-accesorii-vehicule",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___ro"
  }, {
    path: "/ro/buletin-informativ",
    component: _c3e1f8ba,
    name: "newsletter___ro"
  }, {
    path: "/ro/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___ro"
  }, {
    path: "/ro/cod-promotional",
    component: _e6d1ee48,
    name: "code-promo___ro"
  }, {
    path: "/ro/conditii-generale-de-vanzare",
    component: _06b7b198,
    name: "cgv___ro"
  }, {
    path: "/ro/cont",
    component: _9f1b5da6,
    name: "compte___ro"
  }, {
    path: "/ro/cont-pro",
    component: _444af08a,
    name: "compte-pro___ro"
  }, {
    path: "/ro/contact",
    component: _e64111b4,
    name: "contact___ro"
  }, {
    path: "/ro/cos",
    component: _99507574,
    name: "panier___ro"
  }, {
    path: "/ro/felicitari",
    component: _453c97f6,
    name: "felicitations___ro"
  }, {
    path: "/ro/harta-site-ului",
    component: _21302bc9,
    name: "plan-du-site___ro"
  }, {
    path: "/ro/inregistrare",
    component: _25046844,
    name: "inscription___ro"
  }, {
    path: "/ro/livrare",
    component: _6e9d7217,
    name: "livraison___ro"
  }, {
    path: "/ro/magazin-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___ro"
  }, {
    path: "/ro/marci-vehicule",
    component: _5f4a96e4,
    name: "marques-vehicules___ro"
  }, {
    path: "/ro/mentiuni-legale",
    component: _79a8b8e6,
    name: "mentions-legales___ro"
  }, {
    path: "/ro/oferte-bune",
    component: _5566fc52,
    name: "bonnes-affaires___ro"
  }, {
    path: "/ro/parola-noua",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___ro"
  }, {
    path: "/ro/plata-securizata",
    component: _355382f5,
    name: "paiement-securise___ro"
  }, {
    path: "/ro/politica-de-confidentialitate",
    component: _5e03108b,
    name: "charte-donnees-personnelles___ro"
  }, {
    path: "/ro/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___ro"
  }, {
    path: "/ro/regulamentul-jocului",
    component: _9a99652c,
    name: "reglement-du-jeu___ro"
  }, {
    path: "/ro/retur-rambursare",
    component: _215cb8c8,
    name: "retour-remboursement___ro"
  }, {
    path: "/ro/vanatoare-de-led-uri",
    component: _688b551b,
    name: "chasse-aux-leds___ro"
  }, {
    path: "/sv/black-friday",
    component: _4a00e952,
    name: "black-friday___sv"
  }, {
    path: "/sv/blogg-led-tillbehor-fordon",
    component: _e786ee66,
    name: "blog-led-accessoires-vehicules___sv"
  }, {
    path: "/sv/butik-excideuil",
    component: _3e26f7e4,
    name: "magasin-excideuil___sv"
  }, {
    path: "/sv/calendrier-avent",
    component: _640069a4,
    name: "calendrier-avent___sv"
  }, {
    path: "/sv/fordonsmarken",
    component: _5f4a96e4,
    name: "marques-vehicules___sv"
  }, {
    path: "/sv/fynd",
    component: _5566fc52,
    name: "bonnes-affaires___sv"
  }, {
    path: "/sv/grattis",
    component: _453c97f6,
    name: "felicitations___sv"
  }, {
    path: "/sv/integritetspolicy",
    component: _5e03108b,
    name: "charte-donnees-personnelles___sv"
  }, {
    path: "/sv/juridisk-information",
    component: _79a8b8e6,
    name: "mentions-legales___sv"
  }, {
    path: "/sv/kontakt",
    component: _e64111b4,
    name: "contact___sv"
  }, {
    path: "/sv/konto",
    component: _9f1b5da6,
    name: "compte___sv"
  }, {
    path: "/sv/kopvillkor",
    component: _06b7b198,
    name: "cgv___sv"
  }, {
    path: "/sv/led-jakt",
    component: _688b551b,
    name: "chasse-aux-leds___sv"
  }, {
    path: "/sv/leverans",
    component: _6e9d7217,
    name: "livraison___sv"
  }, {
    path: "/sv/logga-in",
    component: _46e17912,
    name: "connexion___sv"
  }, {
    path: "/sv/nyhetsbrev",
    component: _c3e1f8ba,
    name: "newsletter___sv"
  }, {
    path: "/sv/nytt-losenord",
    component: _41f085fa,
    name: "nouveau-mot-de-passe___sv"
  }, {
    path: "/sv/pro-konto",
    component: _444af08a,
    name: "compte-pro___sv"
  }, {
    path: "/sv/quiz-saint-valentin",
    component: _688c9139,
    name: "quiz-saint-valentin___sv"
  }, {
    path: "/sv/rabattkod",
    component: _e6d1ee48,
    name: "code-promo___sv"
  }, {
    path: "/sv/registrera",
    component: _25046844,
    name: "inscription___sv"
  }, {
    path: "/sv/retur-aterbetalning",
    component: _215cb8c8,
    name: "retour-remboursement___sv"
  }, {
    path: "/sv/saker-betalning",
    component: _355382f5,
    name: "paiement-securise___sv"
  }, {
    path: "/sv/tavlingsregler",
    component: _9a99652c,
    name: "reglement-du-jeu___sv"
  }, {
    path: "/sv/varukorg",
    component: _99507574,
    name: "panier___sv"
  }, {
    path: "/sv/webbplatskarta",
    component: _21302bc9,
    name: "plan-du-site___sv"
  }, {
    path: "/cs/blog-led-prislusenstvi-vozidel/kontrola-osvetleni-vozidla",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___cs"
  }, {
    path: "/cs/blog-led-prislusenstvi-vozidel/nejlepsi-zarovky-potkavacich-svetel-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___cs"
  }, {
    path: "/cs/blog-led-prislusenstvi-vozidel/srovnani-nejlepsi-led-zarovky-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___cs"
  }, {
    path: "/cs/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___cs"
  }, {
    path: "/cs/kdo-jsme/partneri",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___cs"
  }, {
    path: "/cs/kosik/doruceni",
    component: _f1e60bf6,
    name: "panier-livraison___cs"
  }, {
    path: "/cs/kosik/platba",
    component: _d0bd6332,
    name: "panier-paiement___cs"
  }, {
    path: "/cs/kosik/potvrzeni",
    component: _2717c9f1,
    name: "panier-confirmation___cs"
  }, {
    path: "/cs/kosik/zruseni",
    component: _4756470e,
    name: "panier-annulation___cs"
  }, {
    path: "/cs/ucet/adresy",
    component: _63ffcc5c,
    name: "compte-adresses___cs"
  }, {
    path: "/cs/ucet/informace",
    component: _01b2313f,
    name: "compte-informations___cs"
  }, {
    path: "/cs/ucet/objednavky",
    component: _cbf4dfd2,
    name: "compte-commandes___cs"
  }, {
    path: "/cs/ucet/oblibene",
    component: _ef98d674,
    name: "compte-favoris___cs"
  }, {
    path: "/cs/ucet/partnersky-program",
    component: _aa8cbf64,
    name: "compte-affiliation___cs"
  }, {
    path: "/cs/ucet/profesional",
    component: _e2b0df12,
    name: "compte-professionnel___cs"
  }, {
    path: "/cs/ucet/ulozene-kosiky",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___cs"
  }, {
    path: "/cs/ucet/upozorneni-na-dostupnost",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___cs"
  }, {
    path: "/cs/ucet/vraceni-produktu",
    component: _5bb4f147,
    name: "compte-retours-produits___cs"
  }, {
    path: "/cs/ucet/zakaznicky-servis",
    component: _20ce67ca,
    name: "compte-service-client___cs"
  }, {
    path: "/da/blog-led-tilbehoer-koeretoejer/bedste-naerlys-paerer-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___da"
  }, {
    path: "/da/blog-led-tilbehoer-koeretoejer/kontroller-bilbelysning",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___da"
  }, {
    path: "/da/blog-led-tilbehoer-koeretoejer/sammenligning-bedste-led-paerer-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___da"
  }, {
    path: "/da/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___da"
  }, {
    path: "/da/konto/adresser",
    component: _63ffcc5c,
    name: "compte-adresses___da"
  }, {
    path: "/da/konto/affiliate",
    component: _aa8cbf64,
    name: "compte-affiliation___da"
  }, {
    path: "/da/konto/erhverv",
    component: _e2b0df12,
    name: "compte-professionnel___da"
  }, {
    path: "/da/konto/favoritter",
    component: _ef98d674,
    name: "compte-favoris___da"
  }, {
    path: "/da/konto/gemte-kurve",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___da"
  }, {
    path: "/da/konto/kundeservice",
    component: _20ce67ca,
    name: "compte-service-client___da"
  }, {
    path: "/da/konto/oplysninger",
    component: _01b2313f,
    name: "compte-informations___da"
  }, {
    path: "/da/konto/ordrer",
    component: _cbf4dfd2,
    name: "compte-commandes___da"
  }, {
    path: "/da/konto/produktretur",
    component: _5bb4f147,
    name: "compte-retours-produits___da"
  }, {
    path: "/da/konto/tilgaengelighedsnotifikationer",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___da"
  }, {
    path: "/da/kurv/annullering",
    component: _4756470e,
    name: "panier-annulation___da"
  }, {
    path: "/da/kurv/bekraeftelse",
    component: _2717c9f1,
    name: "panier-confirmation___da"
  }, {
    path: "/da/kurv/betaling",
    component: _d0bd6332,
    name: "panier-paiement___da"
  }, {
    path: "/da/kurv/levering",
    component: _f1e60bf6,
    name: "panier-livraison___da"
  }, {
    path: "/da/om-os/partnere",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___da"
  }, {
    path: "/de/blog-led-zubehoer-fahrzeuge/beleuchtung-auto-pruefen",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___de"
  }, {
    path: "/de/blog-led-zubehoer-fahrzeuge/beste-abblendlicht-lampen-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___de"
  }, {
    path: "/de/blog-led-zubehoer-fahrzeuge/vergleich-beste-h7-led-lampen",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___de"
  }, {
    path: "/de/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___de"
  }, {
    path: "/de/konto/adressen",
    component: _63ffcc5c,
    name: "compte-adresses___de"
  }, {
    path: "/de/konto/bestellungen",
    component: _cbf4dfd2,
    name: "compte-commandes___de"
  }, {
    path: "/de/konto/favoriten",
    component: _ef98d674,
    name: "compte-favoris___de"
  }, {
    path: "/de/konto/gespeicherte-warenkoerbe",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___de"
  }, {
    path: "/de/konto/informationen",
    component: _01b2313f,
    name: "compte-informations___de"
  }, {
    path: "/de/konto/kundenservice",
    component: _20ce67ca,
    name: "compte-service-client___de"
  }, {
    path: "/de/konto/partnerschaft",
    component: _aa8cbf64,
    name: "compte-affiliation___de"
  }, {
    path: "/de/konto/produkt-ruecksendungen",
    component: _5bb4f147,
    name: "compte-retours-produits___de"
  }, {
    path: "/de/konto/professionell",
    component: _e2b0df12,
    name: "compte-professionnel___de"
  }, {
    path: "/de/konto/verfuegbarkeits-benachrichtigungen",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___de"
  }, {
    path: "/de/warenkorb/bestaetigung",
    component: _2717c9f1,
    name: "panier-confirmation___de"
  }, {
    path: "/de/warenkorb/lieferung",
    component: _f1e60bf6,
    name: "panier-livraison___de"
  }, {
    path: "/de/warenkorb/stornierung",
    component: _4756470e,
    name: "panier-annulation___de"
  }, {
    path: "/de/warenkorb/zahlung",
    component: _d0bd6332,
    name: "panier-paiement___de"
  }, {
    path: "/de/wer-sind-wir/partner",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___de"
  }, {
    path: "/el/blog-led-aksesouar-ochimaton/elegxos-fotismou-aftokinitou",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___el"
  }, {
    path: "/el/blog-led-aksesouar-ochimaton/kalyteres-lampes-fota-diastavrosis-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___el"
  }, {
    path: "/el/blog-led-aksesouar-ochimaton/sygkritiko-kalyteres-lampes-led-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___el"
  }, {
    path: "/el/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___el"
  }, {
    path: "/el/kalathi/akyrosi",
    component: _4756470e,
    name: "panier-annulation___el"
  }, {
    path: "/el/kalathi/epivevaiosi",
    component: _2717c9f1,
    name: "panier-confirmation___el"
  }, {
    path: "/el/kalathi/paradosi",
    component: _f1e60bf6,
    name: "panier-livraison___el"
  }, {
    path: "/el/kalathi/pliromi",
    component: _d0bd6332,
    name: "panier-paiement___el"
  }, {
    path: "/el/logariasmos/agapimena",
    component: _ef98d674,
    name: "compte-favoris___el"
  }, {
    path: "/el/logariasmos/apothikevmena-kalathia",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___el"
  }, {
    path: "/el/logariasmos/diefthynseis",
    component: _63ffcc5c,
    name: "compte-adresses___el"
  }, {
    path: "/el/logariasmos/eidopoiiseis-diathesimotitas",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___el"
  }, {
    path: "/el/logariasmos/eksypiretisi-pelaton",
    component: _20ce67ca,
    name: "compte-service-client___el"
  }, {
    path: "/el/logariasmos/epaggelmatias",
    component: _e2b0df12,
    name: "compte-professionnel___el"
  }, {
    path: "/el/logariasmos/epistrofes-proionton",
    component: _5bb4f147,
    name: "compte-retours-produits___el"
  }, {
    path: "/el/logariasmos/paraggelies",
    component: _cbf4dfd2,
    name: "compte-commandes___el"
  }, {
    path: "/el/logariasmos/plirofories",
    component: _01b2313f,
    name: "compte-informations___el"
  }, {
    path: "/el/logariasmos/synergasia",
    component: _aa8cbf64,
    name: "compte-affiliation___el"
  }, {
    path: "/el/poioi-eimaste/synergates",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___el"
  }, {
    path: "/en/account/addresses",
    component: _63ffcc5c,
    name: "compte-adresses___en"
  }, {
    path: "/en/account/affiliation",
    component: _aa8cbf64,
    name: "compte-affiliation___en"
  }, {
    path: "/en/account/availability-alerts",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___en"
  }, {
    path: "/en/account/customer-service",
    component: _20ce67ca,
    name: "compte-service-client___en"
  }, {
    path: "/en/account/favorites",
    component: _ef98d674,
    name: "compte-favoris___en"
  }, {
    path: "/en/account/information",
    component: _01b2313f,
    name: "compte-informations___en"
  }, {
    path: "/en/account/orders",
    component: _cbf4dfd2,
    name: "compte-commandes___en"
  }, {
    path: "/en/account/product-returns",
    component: _5bb4f147,
    name: "compte-retours-produits___en"
  }, {
    path: "/en/account/professional",
    component: _e2b0df12,
    name: "compte-professionnel___en"
  }, {
    path: "/en/account/saved-carts",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___en"
  }, {
    path: "/en/blog-led-vehicle-accessories/best-h7-led-bulbs-comparison",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___en"
  }, {
    path: "/en/blog-led-vehicle-accessories/best-low-beam-bulbs-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___en"
  }, {
    path: "/en/blog-led-vehicle-accessories/check-car-lights",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___en"
  }, {
    path: "/en/cart/cancellation",
    component: _4756470e,
    name: "panier-annulation___en"
  }, {
    path: "/en/cart/checkout",
    component: _d0bd6332,
    name: "panier-paiement___en"
  }, {
    path: "/en/cart/confirmation",
    component: _2717c9f1,
    name: "panier-confirmation___en"
  }, {
    path: "/en/cart/delivery",
    component: _f1e60bf6,
    name: "panier-livraison___en"
  }, {
    path: "/en/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___en"
  }, {
    path: "/en/who-we-are/partners",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___en"
  }, {
    path: "/es/blog-led-accesorios-vehiculos/comparativa-mejores-bombillas-led-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___es"
  }, {
    path: "/es/blog-led-accesorios-vehiculos/mejores-bombillas-luces-cruce-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___es"
  }, {
    path: "/es/blog-led-accesorios-vehiculos/verificar-iluminacion-coche",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___es"
  }, {
    path: "/es/carrito/cancelacion",
    component: _4756470e,
    name: "panier-annulation___es"
  }, {
    path: "/es/carrito/confirmacion",
    component: _2717c9f1,
    name: "panier-confirmation___es"
  }, {
    path: "/es/carrito/entrega",
    component: _f1e60bf6,
    name: "panier-livraison___es"
  }, {
    path: "/es/carrito/pago",
    component: _d0bd6332,
    name: "panier-paiement___es"
  }, {
    path: "/es/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___es"
  }, {
    path: "/es/cuenta/afiliacion",
    component: _aa8cbf64,
    name: "compte-affiliation___es"
  }, {
    path: "/es/cuenta/alertas-disponibilidad",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___es"
  }, {
    path: "/es/cuenta/carritos-guardados",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___es"
  }, {
    path: "/es/cuenta/devoluciones-productos",
    component: _5bb4f147,
    name: "compte-retours-produits___es"
  }, {
    path: "/es/cuenta/direcciones",
    component: _63ffcc5c,
    name: "compte-adresses___es"
  }, {
    path: "/es/cuenta/favoritos",
    component: _ef98d674,
    name: "compte-favoris___es"
  }, {
    path: "/es/cuenta/informaciones",
    component: _01b2313f,
    name: "compte-informations___es"
  }, {
    path: "/es/cuenta/pedidos",
    component: _cbf4dfd2,
    name: "compte-commandes___es"
  }, {
    path: "/es/cuenta/profesional",
    component: _e2b0df12,
    name: "compte-professionnel___es"
  }, {
    path: "/es/cuenta/servicio-al-cliente",
    component: _20ce67ca,
    name: "compte-service-client___es"
  }, {
    path: "/es/quienes-somos/partners",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___es"
  }, {
    path: "/fi/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___fi"
  }, {
    path: "/fi/keita-olemme/kumppanit",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___fi"
  }, {
    path: "/fi/led-ajoneuvotarvikkeet-blogi/parhaat-lahivalojen-polttimot-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___fi"
  }, {
    path: "/fi/led-ajoneuvotarvikkeet-blogi/tarkista-auton-valaistus",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___fi"
  }, {
    path: "/fi/led-ajoneuvotarvikkeet-blogi/vertailu-parhaat-led-polttimot-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___fi"
  }, {
    path: "/fi/ostoskori/maksu",
    component: _d0bd6332,
    name: "panier-paiement___fi"
  }, {
    path: "/fi/ostoskori/peruutus",
    component: _4756470e,
    name: "panier-annulation___fi"
  }, {
    path: "/fi/ostoskori/toimitus",
    component: _f1e60bf6,
    name: "panier-livraison___fi"
  }, {
    path: "/fi/ostoskori/vahvistus",
    component: _2717c9f1,
    name: "panier-confirmation___fi"
  }, {
    path: "/fi/tili/ammattilainen",
    component: _e2b0df12,
    name: "compte-professionnel___fi"
  }, {
    path: "/fi/tili/asiakaspalvelu",
    component: _20ce67ca,
    name: "compte-service-client___fi"
  }, {
    path: "/fi/tili/kumppanuus",
    component: _aa8cbf64,
    name: "compte-affiliation___fi"
  }, {
    path: "/fi/tili/osoitteet",
    component: _63ffcc5c,
    name: "compte-adresses___fi"
  }, {
    path: "/fi/tili/saatavuushalytykset",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___fi"
  }, {
    path: "/fi/tili/suosikit",
    component: _ef98d674,
    name: "compte-favoris___fi"
  }, {
    path: "/fi/tili/tallennetut-ostoskori",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___fi"
  }, {
    path: "/fi/tili/tiedot",
    component: _01b2313f,
    name: "compte-informations___fi"
  }, {
    path: "/fi/tili/tilaukset",
    component: _cbf4dfd2,
    name: "compte-commandes___fi"
  }, {
    path: "/fi/tili/tuotepalautukset",
    component: _5bb4f147,
    name: "compte-retours-produits___fi"
  }, {
    path: "/it/account/affiliazione",
    component: _aa8cbf64,
    name: "compte-affiliation___it"
  }, {
    path: "/it/account/assistenza-clienti",
    component: _20ce67ca,
    name: "compte-service-client___it"
  }, {
    path: "/it/account/avvisi-disponibilita",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___it"
  }, {
    path: "/it/account/carrelli-salvati",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___it"
  }, {
    path: "/it/account/indirizzi",
    component: _63ffcc5c,
    name: "compte-adresses___it"
  }, {
    path: "/it/account/informazioni",
    component: _01b2313f,
    name: "compte-informations___it"
  }, {
    path: "/it/account/ordini",
    component: _cbf4dfd2,
    name: "compte-commandes___it"
  }, {
    path: "/it/account/preferiti",
    component: _ef98d674,
    name: "compte-favoris___it"
  }, {
    path: "/it/account/professionale",
    component: _e2b0df12,
    name: "compte-professionnel___it"
  }, {
    path: "/it/account/resi-prodotti",
    component: _5bb4f147,
    name: "compte-retours-produits___it"
  }, {
    path: "/it/blog-led-accessori-veicoli/confronto-migliori-lampadine-led-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___it"
  }, {
    path: "/it/blog-led-accessori-veicoli/migliori-lampadine-anabbaglianti-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___it"
  }, {
    path: "/it/blog-led-accessori-veicoli/verificare-illuminazione-auto",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___it"
  }, {
    path: "/it/carrello/annullamento",
    component: _4756470e,
    name: "panier-annulation___it"
  }, {
    path: "/it/carrello/conferma",
    component: _2717c9f1,
    name: "panier-confirmation___it"
  }, {
    path: "/it/carrello/consegna",
    component: _f1e60bf6,
    name: "panier-livraison___it"
  }, {
    path: "/it/carrello/pagamento",
    component: _d0bd6332,
    name: "panier-paiement___it"
  }, {
    path: "/it/chi-siamo/partner",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___it"
  }, {
    path: "/it/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___it"
  }, {
    path: "/ja/akaundo/afirieito",
    component: _aa8cbf64,
    name: "compte-affiliation___ja"
  }, {
    path: "/ja/akaundo/chumon",
    component: _cbf4dfd2,
    name: "compte-commandes___ja"
  }, {
    path: "/ja/akaundo/joho",
    component: _01b2313f,
    name: "compte-informations___ja"
  }, {
    path: "/ja/akaundo/jusho",
    component: _63ffcc5c,
    name: "compte-adresses___ja"
  }, {
    path: "/ja/akaundo/kasutamasabisu",
    component: _20ce67ca,
    name: "compte-service-client___ja"
  }, {
    path: "/ja/akaundo/okiniiri",
    component: _ef98d674,
    name: "compte-favoris___ja"
  }, {
    path: "/ja/akaundo/purofesshonaru",
    component: _e2b0df12,
    name: "compte-professionnel___ja"
  }, {
    path: "/ja/akaundo/zaiko-arato",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___ja"
  }, {
    path: "/ja/blog-led-akusesari-sharyo/h7-led-barubu-hikaku",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___ja"
  }, {
    path: "/ja/blog-led-akusesari-sharyo/saikou-no-barubu-robiimu-pujo-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___ja"
  }, {
    path: "/ja/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___ja"
  }, {
    path: "/ja/kato/haisou",
    component: _f1e60bf6,
    name: "panier-livraison___ja"
  }, {
    path: "/ja/kato/kakunin",
    component: _2717c9f1,
    name: "panier-confirmation___ja"
  }, {
    path: "/ja/kato/kyanseru",
    component: _4756470e,
    name: "panier-annulation___ja"
  }, {
    path: "/ja/kato/shiharai",
    component: _d0bd6332,
    name: "panier-paiement___ja"
  }, {
    path: "/ja/konto/hinpin-henkyaku",
    component: _5bb4f147,
    name: "compte-retours-produits___ja"
  }, {
    path: "/ja/konto/hozon-shita-kago",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___ja"
  }, {
    path: "/ja/watashitachi-ni-tsuite/pa-tona-",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___ja"
  }, {
    path: "/nl/account/adressen",
    component: _63ffcc5c,
    name: "compte-adresses___nl"
  }, {
    path: "/nl/account/affiliatie",
    component: _aa8cbf64,
    name: "compte-affiliation___nl"
  }, {
    path: "/nl/account/beschikbaarheidsmeldingen",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___nl"
  }, {
    path: "/nl/account/bestellingen",
    component: _cbf4dfd2,
    name: "compte-commandes___nl"
  }, {
    path: "/nl/account/favorieten",
    component: _ef98d674,
    name: "compte-favoris___nl"
  }, {
    path: "/nl/account/informatie",
    component: _01b2313f,
    name: "compte-informations___nl"
  }, {
    path: "/nl/account/klantenservice",
    component: _20ce67ca,
    name: "compte-service-client___nl"
  }, {
    path: "/nl/account/opgeslagen-winkelwagens",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___nl"
  }, {
    path: "/nl/account/product-retouren",
    component: _5bb4f147,
    name: "compte-retours-produits___nl"
  }, {
    path: "/nl/account/professioneel",
    component: _e2b0df12,
    name: "compte-professionnel___nl"
  }, {
    path: "/nl/blog-led-accessoires-voertuigen/autoverlichting-controleren",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___nl"
  }, {
    path: "/nl/blog-led-accessoires-voertuigen/beste-lampen-dimlichten-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___nl"
  }, {
    path: "/nl/blog-led-accessoires-voertuigen/vergelijking-beste-h7-led-lampen",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___nl"
  }, {
    path: "/nl/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___nl"
  }, {
    path: "/nl/wie-zijn-wij/partners",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___nl"
  }, {
    path: "/nl/winkelwagen/annulering",
    component: _4756470e,
    name: "panier-annulation___nl"
  }, {
    path: "/nl/winkelwagen/betaling",
    component: _d0bd6332,
    name: "panier-paiement___nl"
  }, {
    path: "/nl/winkelwagen/bevestiging",
    component: _2717c9f1,
    name: "panier-confirmation___nl"
  }, {
    path: "/nl/winkelwagen/levering",
    component: _f1e60bf6,
    name: "panier-livraison___nl"
  }, {
    path: "/no/blogg-led-tilbehor-kjoretoy/beste-naerlys-paerer-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___no"
  }, {
    path: "/no/blogg-led-tilbehor-kjoretoy/kontrollere-bilbelysning",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___no"
  }, {
    path: "/no/blogg-led-tilbehor-kjoretoy/sammenligning-beste-led-paerer-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___no"
  }, {
    path: "/no/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___no"
  }, {
    path: "/no/handlekurv/avbryt",
    component: _4756470e,
    name: "panier-annulation___no"
  }, {
    path: "/no/handlekurv/bekreftelse",
    component: _2717c9f1,
    name: "panier-confirmation___no"
  }, {
    path: "/no/handlekurv/betaling",
    component: _d0bd6332,
    name: "panier-paiement___no"
  }, {
    path: "/no/handlekurv/levering",
    component: _f1e60bf6,
    name: "panier-livraison___no"
  }, {
    path: "/no/konto/adresser",
    component: _63ffcc5c,
    name: "compte-adresses___no"
  }, {
    path: "/no/konto/bestillinger",
    component: _cbf4dfd2,
    name: "compte-commandes___no"
  }, {
    path: "/no/konto/favoritter",
    component: _ef98d674,
    name: "compte-favoris___no"
  }, {
    path: "/no/konto/informasjon",
    component: _01b2313f,
    name: "compte-informations___no"
  }, {
    path: "/no/konto/kundeservice",
    component: _20ce67ca,
    name: "compte-service-client___no"
  }, {
    path: "/no/konto/lagrede-handlekurver",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___no"
  }, {
    path: "/no/konto/partnerprogram",
    component: _aa8cbf64,
    name: "compte-affiliation___no"
  }, {
    path: "/no/konto/produktreturer",
    component: _5bb4f147,
    name: "compte-retours-produits___no"
  }, {
    path: "/no/konto/proff",
    component: _e2b0df12,
    name: "compte-professionnel___no"
  }, {
    path: "/no/konto/tilgjengelighetsvarsler",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___no"
  }, {
    path: "/no/om-oss/partnere",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___no"
  }, {
    path: "/pl/blog-led-akcesoria-pojazdow/najlepsze-zarowki-swiatel-mijania-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___pl"
  }, {
    path: "/pl/blog-led-akcesoria-pojazdow/porownanie-najlepszych-zarowek-led-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___pl"
  }, {
    path: "/pl/blog-led-akcesoria-pojazdow/sprawdzanie-oswietlenia-samochodu",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___pl"
  }, {
    path: "/pl/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___pl"
  }, {
    path: "/pl/kim-jestesmy/partnerzy",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___pl"
  }, {
    path: "/pl/konto/adresy",
    component: _63ffcc5c,
    name: "compte-adresses___pl"
  }, {
    path: "/pl/konto/informacje",
    component: _01b2313f,
    name: "compte-informations___pl"
  }, {
    path: "/pl/konto/obsluga-klienta",
    component: _20ce67ca,
    name: "compte-service-client___pl"
  }, {
    path: "/pl/konto/powiadomienia-o-dostepnosci",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___pl"
  }, {
    path: "/pl/konto/profesjonalne",
    component: _e2b0df12,
    name: "compte-professionnel___pl"
  }, {
    path: "/pl/konto/program-partnerski",
    component: _aa8cbf64,
    name: "compte-affiliation___pl"
  }, {
    path: "/pl/konto/ulubione",
    component: _ef98d674,
    name: "compte-favoris___pl"
  }, {
    path: "/pl/konto/zamowienia",
    component: _cbf4dfd2,
    name: "compte-commandes___pl"
  }, {
    path: "/pl/konto/zapisane-koszyki",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___pl"
  }, {
    path: "/pl/konto/zwroty-produktow",
    component: _5bb4f147,
    name: "compte-retours-produits___pl"
  }, {
    path: "/pl/koszyk/anulowanie",
    component: _4756470e,
    name: "panier-annulation___pl"
  }, {
    path: "/pl/koszyk/dostawa",
    component: _f1e60bf6,
    name: "panier-livraison___pl"
  }, {
    path: "/pl/koszyk/platnosc",
    component: _d0bd6332,
    name: "panier-paiement___pl"
  }, {
    path: "/pl/koszyk/potwierdzenie",
    component: _2717c9f1,
    name: "panier-confirmation___pl"
  }, {
    path: "/pt/blog-led-acessorios-veiculos/comparacao-melhores-lampadas-led-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___pt"
  }, {
    path: "/pt/blog-led-acessorios-veiculos/melhores-lampadas-farol-baixo-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___pt"
  }, {
    path: "/pt/blog-led-acessorios-veiculos/verificar-iluminacao-carro",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___pt"
  }, {
    path: "/pt/carrinho/cancelamento",
    component: _4756470e,
    name: "panier-annulation___pt"
  }, {
    path: "/pt/carrinho/confirmacao",
    component: _2717c9f1,
    name: "panier-confirmation___pt"
  }, {
    path: "/pt/carrinho/entrega",
    component: _f1e60bf6,
    name: "panier-livraison___pt"
  }, {
    path: "/pt/carrinho/pagamento",
    component: _d0bd6332,
    name: "panier-paiement___pt"
  }, {
    path: "/pt/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___pt"
  }, {
    path: "/pt/conta/afiliacao",
    component: _aa8cbf64,
    name: "compte-affiliation___pt"
  }, {
    path: "/pt/conta/alertas-disponibilidade",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___pt"
  }, {
    path: "/pt/conta/atendimento-ao-cliente",
    component: _20ce67ca,
    name: "compte-service-client___pt"
  }, {
    path: "/pt/conta/carrinhos-salvos",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___pt"
  }, {
    path: "/pt/conta/devolucoes-produtos",
    component: _5bb4f147,
    name: "compte-retours-produits___pt"
  }, {
    path: "/pt/conta/enderecos",
    component: _63ffcc5c,
    name: "compte-adresses___pt"
  }, {
    path: "/pt/conta/favoritos",
    component: _ef98d674,
    name: "compte-favoris___pt"
  }, {
    path: "/pt/conta/informacoes",
    component: _01b2313f,
    name: "compte-informations___pt"
  }, {
    path: "/pt/conta/pedidos",
    component: _cbf4dfd2,
    name: "compte-commandes___pt"
  }, {
    path: "/pt/conta/profissional",
    component: _e2b0df12,
    name: "compte-professionnel___pt"
  }, {
    path: "/pt/quem-somos/parceiros",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___pt"
  }, {
    path: "/ro/blog-led-accesorii-vehicule/cele-mai-bune-becuri-faruri-faza-scurta-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___ro"
  }, {
    path: "/ro/blog-led-accesorii-vehicule/comparatie-cele-mai-bune-becuri-led-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___ro"
  }, {
    path: "/ro/blog-led-accesorii-vehicule/verificare-iluminare-auto",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___ro"
  }, {
    path: "/ro/cine-suntem/parteneri",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___ro"
  }, {
    path: "/ro/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___ro"
  }, {
    path: "/ro/cont/adrese",
    component: _63ffcc5c,
    name: "compte-adresses___ro"
  }, {
    path: "/ro/cont/afiliere",
    component: _aa8cbf64,
    name: "compte-affiliation___ro"
  }, {
    path: "/ro/cont/alerte-disponibilitate",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___ro"
  }, {
    path: "/ro/cont/comenzi",
    component: _cbf4dfd2,
    name: "compte-commandes___ro"
  }, {
    path: "/ro/cont/cosuri-salvate",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___ro"
  }, {
    path: "/ro/cont/favorite",
    component: _ef98d674,
    name: "compte-favoris___ro"
  }, {
    path: "/ro/cont/informatii",
    component: _01b2313f,
    name: "compte-informations___ro"
  }, {
    path: "/ro/cont/profesional",
    component: _e2b0df12,
    name: "compte-professionnel___ro"
  }, {
    path: "/ro/cont/retururi-produse",
    component: _5bb4f147,
    name: "compte-retours-produits___ro"
  }, {
    path: "/ro/cont/serviciu-clienti",
    component: _20ce67ca,
    name: "compte-service-client___ro"
  }, {
    path: "/ro/cos/anulare",
    component: _4756470e,
    name: "panier-annulation___ro"
  }, {
    path: "/ro/cos/confirmare",
    component: _2717c9f1,
    name: "panier-confirmation___ro"
  }, {
    path: "/ro/cos/livrare",
    component: _f1e60bf6,
    name: "panier-livraison___ro"
  }, {
    path: "/ro/cos/plata",
    component: _d0bd6332,
    name: "panier-paiement___ro"
  }, {
    path: "/sv/blogg-led-tillbehor-fordon/basta-halvljuslampor-peugeot-2008",
    component: _6c02e62f,
    name: "blog-led-accessoires-vehicules-meilleures-ampoules-feux-de-croisement-peugeot-2008___sv"
  }, {
    path: "/sv/blogg-led-tillbehor-fordon/jamforelse-basta-led-lampor-h7",
    component: _994db1d0,
    name: "blog-led-accessoires-vehicules-comparatif-meilleures-ampoules-led-h7___sv"
  }, {
    path: "/sv/blogg-led-tillbehor-fordon/kontrollera-bilbelysning",
    component: _fc512550,
    name: "blog-led-accessoires-vehicules-verifier-eclairage-voiture___sv"
  }, {
    path: "/sv/compte/historique",
    component: _7def1a1c,
    name: "compte-historique___sv"
  }, {
    path: "/sv/konto/adresser",
    component: _63ffcc5c,
    name: "compte-adresses___sv"
  }, {
    path: "/sv/konto/affiliate",
    component: _aa8cbf64,
    name: "compte-affiliation___sv"
  }, {
    path: "/sv/konto/bestallningar",
    component: _cbf4dfd2,
    name: "compte-commandes___sv"
  }, {
    path: "/sv/konto/favoriter",
    component: _ef98d674,
    name: "compte-favoris___sv"
  }, {
    path: "/sv/konto/kundtjanst",
    component: _20ce67ca,
    name: "compte-service-client___sv"
  }, {
    path: "/sv/konto/produktreturer",
    component: _5bb4f147,
    name: "compte-retours-produits___sv"
  }, {
    path: "/sv/konto/proffs",
    component: _e2b0df12,
    name: "compte-professionnel___sv"
  }, {
    path: "/sv/konto/sparade-varukorgar",
    component: _3c7a31db,
    name: "compte-paniers-sauvegardes___sv"
  }, {
    path: "/sv/konto/tillganglighetsaviseringar",
    component: _4b6ee898,
    name: "compte-alertes-disponibilite___sv"
  }, {
    path: "/sv/konto/uppgifter",
    component: _01b2313f,
    name: "compte-informations___sv"
  }, {
    path: "/sv/om-oss/partners",
    component: _4302616d,
    name: "qui-sommes-nous-partenaires___sv"
  }, {
    path: "/sv/varukorg/avbryt",
    component: _4756470e,
    name: "panier-annulation___sv"
  }, {
    path: "/sv/varukorg/bekraftelse",
    component: _2717c9f1,
    name: "panier-confirmation___sv"
  }, {
    path: "/sv/varukorg/betalning",
    component: _d0bd6332,
    name: "panier-paiement___sv"
  }, {
    path: "/sv/varukorg/leverans",
    component: _f1e60bf6,
    name: "panier-livraison___sv"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index___fr"
  }, {
    path: "/cs/kdo-jsme/montaz-led-prislusenstvi-vozidel/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___cs"
  }, {
    path: "/cs/prodejna-excideuil/realizace/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___cs"
  }, {
    path: "/cs/ucet/objednavky/:id",
    component: _74dac782,
    name: "compte-commandes-id___cs"
  }, {
    path: "/cs/ucet/vraceni-produktu/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___cs"
  }, {
    path: "/cs/ucet/zakaznicky-servis/:id",
    component: _5f911943,
    name: "compte-service-client-id___cs"
  }, {
    path: "/da/butik-excideuil/projekter/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___da"
  }, {
    path: "/da/konto/kundeservice/:id",
    component: _5f911943,
    name: "compte-service-client-id___da"
  }, {
    path: "/da/konto/ordrer/:id",
    component: _74dac782,
    name: "compte-commandes-id___da"
  }, {
    path: "/da/konto/produktretur/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___da"
  }, {
    path: "/da/om-os/installation-led-tilbehoer-koeretoejer/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___da"
  }, {
    path: "/de/geschaft-excideuil/projekte/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___de"
  }, {
    path: "/de/konto/bestellungen/:id",
    component: _74dac782,
    name: "compte-commandes-id___de"
  }, {
    path: "/de/konto/kundenservice/:id",
    component: _5f911943,
    name: "compte-service-client-id___de"
  }, {
    path: "/de/konto/produkt-retouren/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___de"
  }, {
    path: "/de/wer-sind-wir/installation-led-zubehoer-fahrzeuge/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___de"
  }, {
    path: "/el/katastima-excideuil/ergasies/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___el"
  }, {
    path: "/el/logariasmos/eksypiretisi-pelaton/:id",
    component: _5f911943,
    name: "compte-service-client-id___el"
  }, {
    path: "/el/logariasmos/epistrofes-proionton/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___el"
  }, {
    path: "/el/logariasmos/paraggelies/:id",
    component: _74dac782,
    name: "compte-commandes-id___el"
  }, {
    path: "/el/poioi-eimaste/egkatastasi-led-aksesouar-ochimaton/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___el"
  }, {
    path: "/en/about-us/led-installation-vehicle-accessories/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___en"
  }, {
    path: "/en/account/customer-service/:id",
    component: _5f911943,
    name: "compte-service-client-id___en"
  }, {
    path: "/en/account/orders/:id",
    component: _74dac782,
    name: "compte-commandes-id___en"
  }, {
    path: "/en/account/product-returns/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___en"
  }, {
    path: "/en/store-excideuil/projects/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___en"
  }, {
    path: "/es/cuenta/devoluciones-productos/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___es"
  }, {
    path: "/es/cuenta/pedidos/:id",
    component: _74dac782,
    name: "compte-commandes-id___es"
  }, {
    path: "/es/cuenta/servicio-al-cliente/:id",
    component: _5f911943,
    name: "compte-service-client-id___es"
  }, {
    path: "/es/quienes-somos/instalacion-led-accesorios-vehiculos/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___es"
  }, {
    path: "/es/tienda-excideuil/proyectos/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___es"
  }, {
    path: "/fi/keita-olemme/led-ajoneuvotarvikkeet-asennus/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___fi"
  }, {
    path: "/fi/myymala-excideuil/toteutukset/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___fi"
  }, {
    path: "/fi/tili/asiakaspalvelu/:id",
    component: _5f911943,
    name: "compte-service-client-id___fi"
  }, {
    path: "/fi/tili/tilaukset/:id",
    component: _74dac782,
    name: "compte-commandes-id___fi"
  }, {
    path: "/fi/tili/tuotepalautukset/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___fi"
  }, {
    path: "/it/account/assistenza-clienti/:id",
    component: _5f911943,
    name: "compte-service-client-id___it"
  }, {
    path: "/it/account/ordini/:id",
    component: _74dac782,
    name: "compte-commandes-id___it"
  }, {
    path: "/it/account/resi-prodotti/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___it"
  }, {
    path: "/it/chi-siamo/installazione-led-accessori-veicoli/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___it"
  }, {
    path: "/it/negozio-excideuil/realizzazioni/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___it"
  }, {
    path: "/ja/akaundo/chumon/:id",
    component: _74dac782,
    name: "compte-commandes-id___ja"
  }, {
    path: "/ja/akaundo/kasutamasabisu/:id",
    component: _5f911943,
    name: "compte-service-client-id___ja"
  }, {
    path: "/ja/konto/henpin-shouhin/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___ja"
  }, {
    path: "/ja/tenpo-excideuil/jisseki/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___ja"
  }, {
    path: "/ja/watashi-tachi-wa/dentou-led-akusesari-sha-setsuzoku/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___ja"
  }, {
    path: "/nl/account/bestellingen/:id",
    component: _74dac782,
    name: "compte-commandes-id___nl"
  }, {
    path: "/nl/account/klantenservice/:id",
    component: _5f911943,
    name: "compte-service-client-id___nl"
  }, {
    path: "/nl/account/product-retouren/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___nl"
  }, {
    path: "/nl/wie-zijn-wij/installatie-led-accessoires-voertuigen/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___nl"
  }, {
    path: "/nl/winkel-excideuil/realisaties/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___nl"
  }, {
    path: "/no/butikk-excideuil/arbeider/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___no"
  }, {
    path: "/no/konto/bestillinger/:id",
    component: _74dac782,
    name: "compte-commandes-id___no"
  }, {
    path: "/no/konto/kundeservice/:id",
    component: _5f911943,
    name: "compte-service-client-id___no"
  }, {
    path: "/no/konto/produktreturer/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___no"
  }, {
    path: "/no/om-oss/montering-led-tilbehor-kjoretoy/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___no"
  }, {
    path: "/pl/kim-jestesmy/montaz-led-akcesoria-pojazdow/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___pl"
  }, {
    path: "/pl/konto/obsluga-klienta/:id",
    component: _5f911943,
    name: "compte-service-client-id___pl"
  }, {
    path: "/pl/konto/zamowienia/:id",
    component: _74dac782,
    name: "compte-commandes-id___pl"
  }, {
    path: "/pl/konto/zwroty-produktow/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___pl"
  }, {
    path: "/pl/sklep-excideuil/realizacje/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___pl"
  }, {
    path: "/pt/conta/atendimento-ao-cliente/:id",
    component: _5f911943,
    name: "compte-service-client-id___pt"
  }, {
    path: "/pt/conta/devolucoes-produtos/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___pt"
  }, {
    path: "/pt/conta/pedidos/:id",
    component: _74dac782,
    name: "compte-commandes-id___pt"
  }, {
    path: "/pt/loja-excideuil/realizacoes/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___pt"
  }, {
    path: "/pt/quem-somos/instalacao-led-acessorios-veiculos/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___pt"
  }, {
    path: "/ro/cine-suntem/instalare-led-accesorii-vehicule/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___ro"
  }, {
    path: "/ro/cont/comenzi/:id",
    component: _74dac782,
    name: "compte-commandes-id___ro"
  }, {
    path: "/ro/cont/retururi-produse/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___ro"
  }, {
    path: "/ro/cont/serviciu-clienti/:id",
    component: _5f911943,
    name: "compte-service-client-id___ro"
  }, {
    path: "/ro/magazin-excideuil/realizari/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___ro"
  }, {
    path: "/sv/butik-excideuil/installationer/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___sv"
  }, {
    path: "/sv/konto/bestallningar/:id",
    component: _74dac782,
    name: "compte-commandes-id___sv"
  }, {
    path: "/sv/konto/kundtjanst/:id",
    component: _5f911943,
    name: "compte-service-client-id___sv"
  }, {
    path: "/sv/konto/produktreturer/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___sv"
  }, {
    path: "/sv/om-oss/installation-led-tillbehor-fordon/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___sv"
  }, {
    path: "/cs/ucet/objednavky/:id/vraceni",
    component: _76db8878,
    name: "compte-commandes-id-retours___cs"
  }, {
    path: "/da/konto/ordrer/:id/retur",
    component: _76db8878,
    name: "compte-commandes-id-retours___da"
  }, {
    path: "/de/konto/bestellungen/:id/rucksendungen",
    component: _76db8878,
    name: "compte-commandes-id-retours___de"
  }, {
    path: "/el/logariasmos/paraggelies/:id/epistrofes",
    component: _76db8878,
    name: "compte-commandes-id-retours___el"
  }, {
    path: "/en/account/orders/:id/returns",
    component: _76db8878,
    name: "compte-commandes-id-retours___en"
  }, {
    path: "/es/cuenta/pedidos/:id/devoluciones",
    component: _76db8878,
    name: "compte-commandes-id-retours___es"
  }, {
    path: "/fi/tili/tilaukset/:id/palautukset",
    component: _76db8878,
    name: "compte-commandes-id-retours___fi"
  }, {
    path: "/it/account/ordini/:id/resi",
    component: _76db8878,
    name: "compte-commandes-id-retours___it"
  }, {
    path: "/ja/konto/chumon/:id/henpin",
    component: _76db8878,
    name: "compte-commandes-id-retours___ja"
  }, {
    path: "/nl/account/bestellingen/:id/retours",
    component: _76db8878,
    name: "compte-commandes-id-retours___nl"
  }, {
    path: "/no/konto/bestillinger/:id/returer",
    component: _76db8878,
    name: "compte-commandes-id-retours___no"
  }, {
    path: "/pl/konto/zamowienia/:id/zwroty",
    component: _76db8878,
    name: "compte-commandes-id-retours___pl"
  }, {
    path: "/pt/conta/pedidos/:id/devolucoes",
    component: _76db8878,
    name: "compte-commandes-id-retours___pt"
  }, {
    path: "/ro/cont/comenzi/:id/retururi",
    component: _76db8878,
    name: "compte-commandes-id-retours___ro"
  }, {
    path: "/sv/konto/bestallningar/:id/returer",
    component: _76db8878,
    name: "compte-commandes-id-retours___sv"
  }, {
    path: "/compte/commandes/:id",
    component: _74dac782,
    name: "compte-commandes-id___fr"
  }, {
    path: "/compte/retours-produits/:id",
    component: _1c8c996f,
    name: "compte-retours-produits-id___fr"
  }, {
    path: "/compte/service-client/:id",
    component: _5f911943,
    name: "compte-service-client-id___fr"
  }, {
    path: "/cs/blog-led-prislusenstvi-vozidel/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___cs"
  }, {
    path: "/cs/fotografie-recenze/:token",
    component: _dbc25856,
    name: "photo-avis-token___cs"
  }, {
    path: "/cs/kategorie/:domain",
    component: _35f76d5d,
    name: "categories-domain___cs"
  }, {
    path: "/cs/nastaveni-newsletteru/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___cs"
  }, {
    path: "/cs/potvrzeni-newsletteru/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___cs"
  }, {
    path: "/cs/pridat-recenzi/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___cs"
  }, {
    path: "/cs/prihlaseni/:provider",
    component: _7ea75f13,
    name: "connexion-provider___cs"
  }, {
    path: "/cs/produkt/:slug",
    component: _35b00bac,
    name: "produit-slug___cs"
  }, {
    path: "/cs/vyhodne-nakupy/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___cs"
  }, {
    path: "/cs/zakaznicky-servis/:id",
    component: _891d5c10,
    name: "service-client-id___cs"
  }, {
    path: "/cs/znacky-vozidel/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___cs"
  }, {
    path: "/da/bekraeftelse-nyhedsbrev/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___da"
  }, {
    path: "/da/blog-led-tilbehoer-koeretoejer/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___da"
  }, {
    path: "/da/foto-anmeldelse/:token",
    component: _dbc25856,
    name: "photo-avis-token___da"
  }, {
    path: "/da/gode-tilbud/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___da"
  }, {
    path: "/da/kategorier/:domain",
    component: _35f76d5d,
    name: "categories-domain___da"
  }, {
    path: "/da/koeretoejsmaerker/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___da"
  }, {
    path: "/da/kundeservice/:id",
    component: _891d5c10,
    name: "service-client-id___da"
  }, {
    path: "/da/log-ind/:provider",
    component: _7ea75f13,
    name: "connexion-provider___da"
  }, {
    path: "/da/nyhedsbrev-indstillinger/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___da"
  }, {
    path: "/da/produkt/:slug",
    component: _35b00bac,
    name: "produit-slug___da"
  }, {
    path: "/da/tilfoej-anmeldelse/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___da"
  }, {
    path: "/de/anmeldung/:provider",
    component: _7ea75f13,
    name: "connexion-provider___de"
  }, {
    path: "/de/bewertung-hinzufuegen/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___de"
  }, {
    path: "/de/blog-led-zubehoer-fahrzeuge/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___de"
  }, {
    path: "/de/fahrzeugmarken/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___de"
  }, {
    path: "/de/foto-bewertung/:token",
    component: _dbc25856,
    name: "photo-avis-token___de"
  }, {
    path: "/de/gute-angebote/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___de"
  }, {
    path: "/de/kategorien/:domain",
    component: _35f76d5d,
    name: "categories-domain___de"
  }, {
    path: "/de/kundenservice/:id",
    component: _891d5c10,
    name: "service-client-id___de"
  }, {
    path: "/de/newsletter-bestaetigung/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___de"
  }, {
    path: "/de/newsletter-einstellungen/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___de"
  }, {
    path: "/de/produkt/:slug",
    component: _35b00bac,
    name: "produit-slug___de"
  }, {
    path: "/el/blog-led-aksesouar-ochimaton/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___el"
  }, {
    path: "/el/eksypiretisi-pelaton/:id",
    component: _891d5c10,
    name: "service-client-id___el"
  }, {
    path: "/el/epivevaiosi-enimerotikou-deltioy/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___el"
  }, {
    path: "/el/foto-kritikis/:token",
    component: _dbc25856,
    name: "photo-avis-token___el"
  }, {
    path: "/el/katigories/:domain",
    component: _35f76d5d,
    name: "categories-domain___el"
  }, {
    path: "/el/markes-ochimaton/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___el"
  }, {
    path: "/el/proion/:slug",
    component: _35b00bac,
    name: "produit-slug___el"
  }, {
    path: "/el/prosfores/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___el"
  }, {
    path: "/el/prosthesi-kritikis/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___el"
  }, {
    path: "/el/protimiseis-enimerotikou-deltioy/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___el"
  }, {
    path: "/el/sundesi/:provider",
    component: _7ea75f13,
    name: "connexion-provider___el"
  }, {
    path: "/en/add-review/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___en"
  }, {
    path: "/en/blog-led-vehicle-accessories/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___en"
  }, {
    path: "/en/categories/:domain",
    component: _35f76d5d,
    name: "categories-domain___en"
  }, {
    path: "/en/customer-service/:id",
    component: _891d5c10,
    name: "service-client-id___en"
  }, {
    path: "/en/good-deals/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___en"
  }, {
    path: "/en/login/:provider",
    component: _7ea75f13,
    name: "connexion-provider___en"
  }, {
    path: "/en/newsletter-confirmation/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___en"
  }, {
    path: "/en/newsletter-preferences/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___en"
  }, {
    path: "/en/product/:slug",
    component: _35b00bac,
    name: "produit-slug___en"
  }, {
    path: "/en/review-photo/:token",
    component: _dbc25856,
    name: "photo-avis-token___en"
  }, {
    path: "/en/vehicle-brands/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___en"
  }, {
    path: "/es/agregar-opinion/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___es"
  }, {
    path: "/es/blog-led-accesorios-vehiculos/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___es"
  }, {
    path: "/es/buenas-ofertas/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___es"
  }, {
    path: "/es/categorias/:domain",
    component: _35f76d5d,
    name: "categories-domain___es"
  }, {
    path: "/es/conexion/:provider",
    component: _7ea75f13,
    name: "connexion-provider___es"
  }, {
    path: "/es/confirmacion-boletin/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___es"
  }, {
    path: "/es/foto-opinion/:token",
    component: _dbc25856,
    name: "photo-avis-token___es"
  }, {
    path: "/es/marcas-vehiculos/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___es"
  }, {
    path: "/es/preferencias-boletin/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___es"
  }, {
    path: "/es/producto/:slug",
    component: _35b00bac,
    name: "produit-slug___es"
  }, {
    path: "/es/servicio-al-cliente/:id",
    component: _891d5c10,
    name: "service-client-id___es"
  }, {
    path: "/fi/ajoneuvomerkit/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___fi"
  }, {
    path: "/fi/asiakaspalvelu/:id",
    component: _891d5c10,
    name: "service-client-id___fi"
  }, {
    path: "/fi/kategoriat/:domain",
    component: _35f76d5d,
    name: "categories-domain___fi"
  }, {
    path: "/fi/kirjaudu/:provider",
    component: _7ea75f13,
    name: "connexion-provider___fi"
  }, {
    path: "/fi/kuva-arvostelu/:token",
    component: _dbc25856,
    name: "photo-avis-token___fi"
  }, {
    path: "/fi/led-ajoneuvotarvikkeet-blogi/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___fi"
  }, {
    path: "/fi/lisaa-arvostelu/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___fi"
  }, {
    path: "/fi/tarjoukset/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___fi"
  }, {
    path: "/fi/tuote/:slug",
    component: _35b00bac,
    name: "produit-slug___fi"
  }, {
    path: "/fi/uutiskirjeen-asetukset/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___fi"
  }, {
    path: "/fi/uutiskirjeen-vahvistus/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___fi"
  }, {
    path: "/it/aggiungi-recensione/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___it"
  }, {
    path: "/it/assistenza-clienti/:id",
    component: _891d5c10,
    name: "service-client-id___it"
  }, {
    path: "/it/blog-led-accessori-veicoli/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___it"
  }, {
    path: "/it/buoni-affari/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___it"
  }, {
    path: "/it/categorie/:domain",
    component: _35f76d5d,
    name: "categories-domain___it"
  }, {
    path: "/it/conferma-newsletter/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___it"
  }, {
    path: "/it/connessione/:provider",
    component: _7ea75f13,
    name: "connexion-provider___it"
  }, {
    path: "/it/foto-recensione/:token",
    component: _dbc25856,
    name: "photo-avis-token___it"
  }, {
    path: "/it/marche-veicoli/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___it"
  }, {
    path: "/it/preferenze-newsletter/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___it"
  }, {
    path: "/it/prodotto/:slug",
    component: _35b00bac,
    name: "produit-slug___it"
  }, {
    path: "/ja/blog-led-akusesari-sharyo/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___ja"
  }, {
    path: "/ja/kasutamasabisu/:id",
    component: _891d5c10,
    name: "service-client-id___ja"
  }, {
    path: "/ja/kategori/:domain",
    component: _35f76d5d,
    name: "categories-domain___ja"
  }, {
    path: "/ja/kuchikomi-toukou/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___ja"
  }, {
    path: "/ja/nyu-su-reta-kakunin/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___ja"
  }, {
    path: "/ja/nyu-su-reta-kibou/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___ja"
  }, {
    path: "/ja/okaidoku/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___ja"
  }, {
    path: "/ja/roguin/:provider",
    component: _7ea75f13,
    name: "connexion-provider___ja"
  }, {
    path: "/ja/seihin/:slug",
    component: _35b00bac,
    name: "produit-slug___ja"
  }, {
    path: "/ja/sharyou-burando/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___ja"
  }, {
    path: "/ja/shashin-kuchikomi/:token",
    component: _dbc25856,
    name: "photo-avis-token___ja"
  }, {
    path: "/magasin-excideuil/realisations/:slug",
    component: _1bd6b702,
    name: "magasin-excideuil-realisations-slug___fr"
  }, {
    path: "/nl/beoordeling-toevoegen/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___nl"
  }, {
    path: "/nl/bevestiging-nieuwsbrief/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___nl"
  }, {
    path: "/nl/blog-led-accessoires-voertuigen/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___nl"
  }, {
    path: "/nl/categorien/:domain",
    component: _35f76d5d,
    name: "categories-domain___nl"
  }, {
    path: "/nl/foto-beoordeling/:token",
    component: _dbc25856,
    name: "photo-avis-token___nl"
  }, {
    path: "/nl/goede-deals/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___nl"
  }, {
    path: "/nl/klantenservice/:id",
    component: _891d5c10,
    name: "service-client-id___nl"
  }, {
    path: "/nl/product/:slug",
    component: _35b00bac,
    name: "produit-slug___nl"
  }, {
    path: "/nl/verbinding/:provider",
    component: _7ea75f13,
    name: "connexion-provider___nl"
  }, {
    path: "/nl/voertuig-merken/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___nl"
  }, {
    path: "/nl/voorkeuren-nieuwsbrief/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___nl"
  }, {
    path: "/no/bekreftelse-nyhetsbrev/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___no"
  }, {
    path: "/no/bilmerker/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___no"
  }, {
    path: "/no/blogg-led-tilbehor-kjoretoy/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___no"
  }, {
    path: "/no/foto-anmeldelse/:token",
    component: _dbc25856,
    name: "photo-avis-token___no"
  }, {
    path: "/no/gode-tilbud/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___no"
  }, {
    path: "/no/innstillinger-nyhetsbrev/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___no"
  }, {
    path: "/no/kategorier/:domain",
    component: _35f76d5d,
    name: "categories-domain___no"
  }, {
    path: "/no/kundeservice/:id",
    component: _891d5c10,
    name: "service-client-id___no"
  }, {
    path: "/no/legg-til-anmeldelse/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___no"
  }, {
    path: "/no/logg-inn/:provider",
    component: _7ea75f13,
    name: "connexion-provider___no"
  }, {
    path: "/no/produkt/:slug",
    component: _35b00bac,
    name: "produit-slug___no"
  }, {
    path: "/pl/blog-led-akcesoria-pojazdow/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___pl"
  }, {
    path: "/pl/dodaj-opinie/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___pl"
  }, {
    path: "/pl/kategorie/:domain",
    component: _35f76d5d,
    name: "categories-domain___pl"
  }, {
    path: "/pl/logowanie/:provider",
    component: _7ea75f13,
    name: "connexion-provider___pl"
  }, {
    path: "/pl/marki-pojazdow/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___pl"
  }, {
    path: "/pl/obsluga-klienta/:id",
    component: _891d5c10,
    name: "service-client-id___pl"
  }, {
    path: "/pl/okazje/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___pl"
  }, {
    path: "/pl/potwierdzenie-newslettera/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___pl"
  }, {
    path: "/pl/preferencje-newslettera/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___pl"
  }, {
    path: "/pl/produkt/:slug",
    component: _35b00bac,
    name: "produit-slug___pl"
  }, {
    path: "/pl/zdjecie-opinii/:token",
    component: _dbc25856,
    name: "photo-avis-token___pl"
  }, {
    path: "/pt/adicionar-avaliacao/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___pt"
  }, {
    path: "/pt/atendimento-ao-cliente/:id",
    component: _891d5c10,
    name: "service-client-id___pt"
  }, {
    path: "/pt/blog-led-acessorios-veiculos/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___pt"
  }, {
    path: "/pt/boas-ofertas/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___pt"
  }, {
    path: "/pt/categorias/:domain",
    component: _35f76d5d,
    name: "categories-domain___pt"
  }, {
    path: "/pt/conexao/:provider",
    component: _7ea75f13,
    name: "connexion-provider___pt"
  }, {
    path: "/pt/confirmacao-boletim-informativo/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___pt"
  }, {
    path: "/pt/foto-avaliacao/:token",
    component: _dbc25856,
    name: "photo-avis-token___pt"
  }, {
    path: "/pt/marcas-veiculos/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___pt"
  }, {
    path: "/pt/preferencias-boletim-informativo/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___pt"
  }, {
    path: "/pt/produto/:slug",
    component: _35b00bac,
    name: "produit-slug___pt"
  }, {
    path: "/qui-sommes-nous/installation-led-accessoires-vehicules/:slug",
    component: _2e273f32,
    name: "qui-sommes-nous-installation-led-accessoires-vehicules-slug___fr"
  }, {
    path: "/ro/adauga-recenzie/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___ro"
  }, {
    path: "/ro/autentificare/:provider",
    component: _7ea75f13,
    name: "connexion-provider___ro"
  }, {
    path: "/ro/blog-led-accesorii-vehicule/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___ro"
  }, {
    path: "/ro/categorii/:domain",
    component: _35f76d5d,
    name: "categories-domain___ro"
  }, {
    path: "/ro/confirmare-buletin-informativ/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___ro"
  }, {
    path: "/ro/fotografie-recenzie/:token",
    component: _dbc25856,
    name: "photo-avis-token___ro"
  }, {
    path: "/ro/marci-vehicule/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___ro"
  }, {
    path: "/ro/oferte-bune/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___ro"
  }, {
    path: "/ro/preferinte-buletin-informativ/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___ro"
  }, {
    path: "/ro/produs/:slug",
    component: _35b00bac,
    name: "produit-slug___ro"
  }, {
    path: "/ro/serviciu-clienti/:id",
    component: _891d5c10,
    name: "service-client-id___ro"
  }, {
    path: "/sv/bekraftelse-nyhetsbrev/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___sv"
  }, {
    path: "/sv/blogg-led-tillbehor-fordon/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___sv"
  }, {
    path: "/sv/fordonsmarken/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___sv"
  }, {
    path: "/sv/foto-recension/:token",
    component: _dbc25856,
    name: "photo-avis-token___sv"
  }, {
    path: "/sv/fynd/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___sv"
  }, {
    path: "/sv/installningar-nyhetsbrev/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___sv"
  }, {
    path: "/sv/kategorier/:domain",
    component: _35f76d5d,
    name: "categories-domain___sv"
  }, {
    path: "/sv/kundtjanst/:id",
    component: _891d5c10,
    name: "service-client-id___sv"
  }, {
    path: "/sv/lagg-till-recension/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___sv"
  }, {
    path: "/sv/logga-in/:provider",
    component: _7ea75f13,
    name: "connexion-provider___sv"
  }, {
    path: "/sv/produkt/:slug",
    component: _35b00bac,
    name: "produit-slug___sv"
  }, {
    path: "/compte/commandes/:id/retours",
    component: _76db8878,
    name: "compte-commandes-id-retours___fr"
  }, {
    path: "/cs/kategorie/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___cs"
  }, {
    path: "/cs/pridat-recenzi/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___cs"
  }, {
    path: "/da/kategorier/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___da"
  }, {
    path: "/da/tilfoej-anmeldelse/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___da"
  }, {
    path: "/de/bewertung-hinzufuegen/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___de"
  }, {
    path: "/de/kategorien/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___de"
  }, {
    path: "/el/katigories/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___el"
  }, {
    path: "/el/prosthesi-kritikis/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___el"
  }, {
    path: "/en/add-review/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___en"
  }, {
    path: "/en/categories/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___en"
  }, {
    path: "/es/agregar-opinion/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___es"
  }, {
    path: "/es/categorias/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___es"
  }, {
    path: "/fi/kategoriat/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___fi"
  }, {
    path: "/fi/lisaa-arvostelu/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___fi"
  }, {
    path: "/it/aggiungi-recensione/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___it"
  }, {
    path: "/it/categorie/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___it"
  }, {
    path: "/ja/kategori/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___ja"
  }, {
    path: "/ja/tsuika-hyouka/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___ja"
  }, {
    path: "/nl/beoordeling-toevoegen/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___nl"
  }, {
    path: "/nl/categorieen/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___nl"
  }, {
    path: "/no/kategorier/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___no"
  }, {
    path: "/no/legg-til-anmeldelse/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___no"
  }, {
    path: "/pl/dodaj-opinie/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___pl"
  }, {
    path: "/pl/kategorie/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___pl"
  }, {
    path: "/pt/adicionar-avaliacao/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___pt"
  }, {
    path: "/pt/categorias/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___pt"
  }, {
    path: "/ro/adauga-recenzie/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___ro"
  }, {
    path: "/ro/categorii/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___ro"
  }, {
    path: "/sv/kategorier/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___sv"
  }, {
    path: "/sv/lagg-till-recension/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___sv"
  }, {
    path: "/cs/kategorie/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___cs"
  }, {
    path: "/cs/vyhledavani-led-prislusenstvi/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___cs"
  }, {
    path: "/da/kategorier/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___da"
  }, {
    path: "/da/soeg-led-tilbehoer/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___da"
  }, {
    path: "/de/kategorien/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___de"
  }, {
    path: "/de/suche-led-zubehoer/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___de"
  }, {
    path: "/el/anazitisi-led-aksesouar/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___el"
  }, {
    path: "/el/katigories/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___el"
  }, {
    path: "/en/categories/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___en"
  }, {
    path: "/en/search-led-accessories/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___en"
  }, {
    path: "/es/busqueda-led-accesorios/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___es"
  }, {
    path: "/es/categorias/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___es"
  }, {
    path: "/fi/haku-led-ajoneuvotarvikkeet/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___fi"
  }, {
    path: "/fi/kategoriat/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___fi"
  }, {
    path: "/it/categorie/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___it"
  }, {
    path: "/it/ricerca-led-accessori/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___it"
  }, {
    path: "/ja/kategori/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___ja"
  }, {
    path: "/ja/led-akusesari-kensaku/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___ja"
  }, {
    path: "/nl/categorieen/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___nl"
  }, {
    path: "/nl/zoek-led-accessoires/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___nl"
  }, {
    path: "/no/kategorier/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___no"
  }, {
    path: "/no/sok-led-tilbehor/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___no"
  }, {
    path: "/pl/kategorie/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___pl"
  }, {
    path: "/pl/wyszukiwanie-led-akcesoria/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___pl"
  }, {
    path: "/pt/categorias/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___pt"
  }, {
    path: "/pt/pesquisa-led-acessorios/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___pt"
  }, {
    path: "/ro/categorii/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___ro"
  }, {
    path: "/ro/cautare-led-accesorii/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___ro"
  }, {
    path: "/sv/kategorier/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___sv"
  }, {
    path: "/sv/sok-led-tillbehor/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___sv"
  }, {
    path: "/ajout-avis/:token",
    component: _1686c2aa,
    name: "ajout-avis-token___fr"
  }, {
    path: "/blog-led-accessoires-vehicules/:slug",
    component: _eaf430f6,
    name: "blog-led-accessoires-vehicules-slug___fr"
  }, {
    path: "/bonnes-affaires/:slug",
    component: _53b05b0a,
    name: "bonnes-affaires-slug___fr"
  }, {
    path: "/categories/:domain",
    component: _35f76d5d,
    name: "categories-domain___fr"
  }, {
    path: "/confirmation-newsletter/:token",
    component: _2b7259e2,
    name: "confirmation-newsletter-token___fr"
  }, {
    path: "/connexion/:provider",
    component: _7ea75f13,
    name: "connexion-provider___fr"
  }, {
    path: "/marques-vehicules/:slug",
    component: _5d93f59c,
    name: "marques-vehicules-slug___fr"
  }, {
    path: "/photo-avis/:token",
    component: _dbc25856,
    name: "photo-avis-token___fr"
  }, {
    path: "/preferences-newsletter/:token",
    component: _a8d682fe,
    name: "preferences-newsletter-token___fr"
  }, {
    path: "/produit/:slug",
    component: _35b00bac,
    name: "produit-slug___fr"
  }, {
    path: "/service-client/:id",
    component: _891d5c10,
    name: "service-client-id___fr"
  }, {
    path: "/ajout-avis/:token/:id",
    component: _e4af605a,
    name: "ajout-avis-token-id___fr"
  }, {
    path: "/categories/:domain/:category",
    component: _06c0872a,
    name: "categories-domain-category___fr"
  }, {
    path: "/categories/:domain/:category/:subcategory",
    component: _32165d79,
    name: "categories-domain-category-subcategory___fr"
  }, {
    path: "/recherche-led-accessoires/:brand/:type/:typeid",
    component: _85cc14f6,
    name: "recherche-led-accessoires-brand-type-typeid___fr"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
